import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
};

export type AcademicalTestimonialInput = {
  sickLeaveEnd: Scalars['DateTime']['input'];
  sickLeaveStart: Scalars['DateTime']['input'];
  testimonialGoal: Scalars['String']['input'];
};

export type ActiveSubstance = {
  __typename?: 'ActiveSubstance';
  activeSubstanceDose?: Maybe<Scalars['Int']['output']>;
  activeSubstanceDoseInWords?: Maybe<Array<Scalars['String']['output']>>;
  activeSubstanceDoseUnit?: Maybe<Scalars['String']['output']>;
};

export type ActiveSubstanceOfDrug = {
  __typename?: 'ActiveSubstanceOfDrug';
  amountPerItem?: Maybe<Scalars['String']['output']>;
  amountPerPackage?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  substanceId?: Maybe<Scalars['String']['output']>;
  unitCode?: Maybe<Scalars['String']['output']>;
};

export type AdditionalRefundRight =
  | 'AZ'
  | 'BW'
  | 'C'
  | 'CN'
  | 'DN'
  | 'DZ'
  | 'IB'
  | 'IN'
  | 'IW'
  | 'PO'
  | 'S'
  | 'WP'
  | 'ZK';

export type Address = {
  __typename?: 'Address';
  apiDump?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  flatNumber?: Maybe<Scalars['String']['output']>;
  houseNumber: Scalars['String']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  location?: Maybe<Location>;
  longitude?: Maybe<Scalars['Float']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  street: Scalars['String']['output'];
  teryt?: Maybe<Scalars['String']['output']>;
  zipCode: Scalars['String']['output'];
};

export type Analysis = BaseVital & Global & {
  __typename?: 'Analysis';
  analysisType: Scalars['String']['output'];
  createdAt: Time;
  customDate?: Maybe<Time>;
  delivered?: Maybe<Time>;
  doctor?: Maybe<Doctor>;
  doctorId: Scalars['String']['output'];
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  measured?: Maybe<Time>;
  message?: Maybe<Message>;
  messageId: Scalars['String']['output'];
  overrideFiles?: Maybe<Array<Scalars['String']['output']>>;
  params: Array<BloodParam>;
  patient?: Maybe<Patient>;
  patientId: Scalars['String']['output'];
  type: VitalType;
  updatedAt: Time;
  visit?: Maybe<Visit>;
  visitId: Scalars['String']['output'];
};

export type AnalyticsData = {
  __typename?: 'AnalyticsData';
  data: Scalars['JSON']['output'];
  source: RegistrationSource;
};

export type AnotherPaymentMethodInfo = {
  __typename?: 'AnotherPaymentMethodInfo';
  comment: Scalars['String']['output'];
};

export type AnotherPaymentMethodInfoInput = {
  comment: Scalars['String']['input'];
};

export type Answer = {
  __typename?: 'Answer';
  choice_id: Scalars['String']['output'];
  id: Scalars['String']['output'];
  initial: Scalars['Boolean']['output'];
  source: Scalars['String']['output'];
};

export type AppointmentStatus =
  | 'CONFIRMED'
  | 'EMPTY'
  | 'INDETERMINATE';

export type Assignment = BaseMessage & Global & {
  __typename?: 'Assignment';
  assignmentType: Scalars['String']['output'];
  createdAt: Time;
  data?: Maybe<Scalars['JSON']['output']>;
  doctor: Doctor;
  doctorId: Scalars['String']['output'];
  duration?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  invoiceId?: Maybe<Scalars['String']['output']>;
  maker: Doctor;
  makerId?: Maybe<Scalars['String']['output']>;
  paid?: Maybe<Scalars['Boolean']['output']>;
  patient: Patient;
  patientId: Scalars['String']['output'];
  plannedPlace?: Maybe<Scalars['String']['output']>;
  plannedStart?: Maybe<Time>;
  positions?: Maybe<Array<Maybe<Position>>>;
  signatureFile?: Maybe<Scalars['String']['output']>;
  status?: Maybe<AssignmentStatus>;
  stripeSessionId: Scalars['String']['output'];
  type: MessageType;
  updatedAt: Time;
  visit: Visit;
  visitId: Scalars['String']['output'];
  vitals: Array<VitalEntity>;
};

export type AssignmentEntity = {
  __typename?: 'AssignmentEntity';
  color?: Maybe<Scalars['String']['output']>;
  entrustedBudgetPriceInDecimal?: Maybe<Scalars['Float']['output']>;
  faqType: AssignmentFaqType;
  foreignServiceId: Scalars['String']['output'];
  icd9?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  jednCode?: Maybe<Scalars['String']['output']>;
  material?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nfzPossible: Scalars['Boolean']['output'];
  nfzPossibleForNurse: Scalars['Boolean']['output'];
  saleorProductId: Scalars['String']['output'];
  type: AssignmentType;
};

export type AssignmentFaqType =
  | 'BLOOD'
  | 'DAILY_URINE_COLLECTION'
  | 'NONE'
  | 'OGTT'
  | 'STOOL'
  | 'URINE_GENERAL'
  | 'URINE_MICROBIOLOGY';

export type AssignmentStatus =
  | 'DONE'
  | 'IN_PROGRESS'
  | 'NOT_DONE'
  | 'RESULTS';

export type AssignmentType =
  | 'IMAGE'
  | 'IMMUNIZATION'
  | 'LABORATORY'
  | 'OTHER'
  | 'QUICKTEST';

export type BankTransferPaymentInfo = {
  __typename?: 'BankTransferPaymentInfo';
  moneyTransferProofFiles: Array<Scalars['String']['output']>;
};

export type BankTransferPaymentInfoInput = {
  moneyTransferProofFiles: Array<Scalars['String']['input']>;
};

export type BaseMessage = {
  createdAt: Time;
  doctorId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  patientId: Scalars['String']['output'];
  stripeSessionId: Scalars['String']['output'];
  type: MessageType;
  updatedAt: Time;
  visitId: Scalars['String']['output'];
};

export type BaseUser = {
  avatar?: Maybe<Scalars['String']['output']>;
  consultantInfo: Scalars['JSON']['output'];
  createdAt: Time;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  genre: UserGenre;
  id: Scalars['String']['output'];
  lastLogin: Time;
  lastName?: Maybe<Scalars['String']['output']>;
  passwordHash: Scalars['String']['output'];
  pesel?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  realNFZStatus: RealNFZStatusType;
  updatedAt: Time;
};

export type BaseVital = {
  createdAt: Time;
  customDate?: Maybe<Time>;
  delivered?: Maybe<Time>;
  doctorId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  measured?: Maybe<Time>;
  messageId: Scalars['String']['output'];
  overrideFiles?: Maybe<Array<Scalars['String']['output']>>;
  patientId: Scalars['String']['output'];
  type: VitalType;
  updatedAt: Time;
  visitId: Scalars['String']['output'];
};

export type BecikoweTestimonialInput = {
  dateOfFirstTrimesterVisit: Scalars['DateTime']['input'];
  dateOfSecondTrimesterVisit: Scalars['DateTime']['input'];
  dateOfThirdTrimesterVisit: Scalars['DateTime']['input'];
  weeksUnderMedicalCare: Scalars['Float']['input'];
};

export type BloodParam = {
  __typename?: 'BloodParam';
  max?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CareLeaveInput = {
  address: StayAddressInput;
  careSince?: InputMaybe<Scalars['String']['input']>;
  careUntil?: InputMaybe<Scalars['String']['input']>;
  guardian: ConnectionInput;
  icd10Main: ICD10Input;
  insuredIn?: InputMaybe<StateInsurance>;
  payers: Array<PayerInputNew>;
  reason?: InputMaybe<Scalars['String']['input']>;
  visitId: Scalars['String']['input'];
};

export type Careleave = BaseMessage & Global & {
  __typename?: 'Careleave';
  careSince?: Maybe<Scalars['String']['output']>;
  careUntil?: Maybe<Scalars['String']['output']>;
  codes?: Maybe<Codes>;
  createdAt: Time;
  doNotSendPayerInfo?: Maybe<Scalars['Boolean']['output']>;
  doctor: Doctor;
  doctorId: Scalars['String']['output'];
  icd10Main: ICD10Main;
  id: Scalars['String']['output'];
  inabilitySince?: Maybe<Scalars['String']['output']>;
  inabilityUntil?: Maybe<Scalars['String']['output']>;
  insuredIn?: Maybe<Scalars['String']['output']>;
  leaveType?: Maybe<Scalars['String']['output']>;
  leaves?: Maybe<Array<LeaveDetails>>;
  patient: Patient;
  patientId: Scalars['String']['output'];
  payer?: Maybe<Payer>;
  payers?: Maybe<Array<Payer>>;
  reason?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['String']['output']>;
  stripeSessionId: Scalars['String']['output'];
  type: MessageType;
  underCarePerson?: Maybe<UnderCarePerson>;
  updatedAt: Time;
  visit: Visit;
  visitId: Scalars['String']['output'];
};

export type ChangePasswordInput = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};

export type ChatMessageCreatedEvent = {
  __typename?: 'ChatMessageCreatedEvent';
  message: ChatMessageEntity;
};

export type ChatMessageDeletedEvent = {
  __typename?: 'ChatMessageDeletedEvent';
  message: ChatMessageEntity;
};

export type ChatMessageEntity = {
  __typename?: 'ChatMessageEntity';
  assignment?: Maybe<Assignment>;
  author?: Maybe<User>;
  authorId?: Maybe<Scalars['String']['output']>;
  authorType: Scalars['String']['output'];
  careleave?: Maybe<Careleave>;
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  leave?: Maybe<Leave>;
  masterId?: Maybe<Scalars['String']['output']>;
  patient: Patient;
  patientId: Scalars['String']['output'];
  prescription?: Maybe<Prescription>;
  referral?: Maybe<Referral>;
  survey?: Maybe<SurveyProposalEntity>;
  testimonial?: Maybe<Testimonial>;
  updatedAt: Scalars['DateTime']['output'];
  visit?: Maybe<Visit>;
};

export type ChatMessageInput = {
  content: Scalars['String']['input'];
};

export type ChatMessagesUpdateEvent = ChatMessageCreatedEvent | ChatMessageDeletedEvent | PrescriptionChatMessageDeletedEvent;

export type Checker = {
  __typename?: 'Checker';
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type ChukBodyMeasurements = {
  __typename?: 'ChukBodyMeasurements';
  height?: Maybe<Scalars['Float']['output']>;
  waist?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type ChukBodyMeasurementsInput = {
  height?: InputMaybe<Scalars['Float']['input']>;
  waist?: InputMaybe<Scalars['Float']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type ChukEducationInput = {
  cholesterol?: InputMaybe<Scalars['Float']['input']>;
  cholesterolHDL?: InputMaybe<Scalars['Float']['input']>;
  cholesterolLDL?: InputMaybe<Scalars['Float']['input']>;
  cholesterolNonHDL?: InputMaybe<Scalars['Float']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  glucose?: InputMaybe<Scalars['Float']['input']>;
  recommendations?: InputMaybe<Scalars['String']['input']>;
  riskScore?: InputMaybe<Scalars['Float']['input']>;
  simpFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  triglycerides?: InputMaybe<Scalars['Float']['input']>;
};

export type ChukMeasurementsInput = {
  bodyMeasurements?: InputMaybe<ChukBodyMeasurementsInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  pressureMeasurements?: InputMaybe<Array<ChukPressureMeasurementInput>>;
};

export type ChukPressureMeasurement = {
  __typename?: 'ChukPressureMeasurement';
  diastolicPressure?: Maybe<Scalars['Float']['output']>;
  pulse?: Maybe<Scalars['Float']['output']>;
  systolicPressure?: Maybe<Scalars['Float']['output']>;
};

export type ChukPressureMeasurementInput = {
  diastolicPressure?: InputMaybe<Scalars['Float']['input']>;
  pulse?: InputMaybe<Scalars['Float']['input']>;
  systolicPressure?: InputMaybe<Scalars['Float']['input']>;
};

export type ClientAppSettings = {
  __typename?: 'ClientAppSettings';
  preferredLocation: Scalars['String']['output'];
};

export type Clinic = {
  __typename?: 'Clinic';
  code: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  type: Scalars['Int']['output'];
};

export type ClinicDetails = {
  __typename?: 'ClinicDetails';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ClinicInput = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  type: Scalars['Int']['input'];
};

export type Codes = {
  __typename?: 'Codes';
  A: Scalars['Boolean']['output'];
  B: Scalars['Boolean']['output'];
  C: Scalars['Boolean']['output'];
  D: Scalars['Boolean']['output'];
  E: Scalars['Boolean']['output'];
};

export type CodesInput = {
  A: Scalars['Boolean']['input'];
  B: Scalars['Boolean']['input'];
  C: Scalars['Boolean']['input'];
  D: Scalars['Boolean']['input'];
  E: Scalars['Boolean']['input'];
};

export type ConfirmationType =
  | 'DOCUMENTATION'
  | 'EXAMINATION'
  | 'INTERVIEW';

export type ConnectionInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  pesel: Scalars['String']['input'];
  type?: InputMaybe<UnderCarePersonType>;
};

export type ControlVisitInput = {
  examinationName?: InputMaybe<Scalars['String']['input']>;
  icd9?: InputMaybe<Scalars['String']['input']>;
  time: IpomTimeType;
  timeUnit?: InputMaybe<IpomTimeUnit>;
  timeValue?: InputMaybe<Scalars['String']['input']>;
};

export type ControlVisitIpom = {
  __typename?: 'ControlVisitIpom';
  examinationName?: Maybe<Scalars['String']['output']>;
  icd9?: Maybe<Scalars['String']['output']>;
  time: IpomTimeType;
  timeUnit?: Maybe<IpomTimeUnit>;
  timeValue?: Maybe<Scalars['String']['output']>;
};

export type CovidExaminationInput = {
  financingSource: FinancingSource;
  notMobilePatient: Scalars['Boolean']['input'];
  visitId: Scalars['String']['input'];
};

export type CreateDocumentInput = {
  createdAt: Scalars['String']['input'];
  fileId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  patientId: Scalars['String']['input'];
  source: MedicalDocumentSource;
  tagId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateIPOMWithOperationResult = {
  __typename?: 'CreateIPOMWithOperationResult';
  ipomCode: Scalars['String']['output'];
};

export type CreateIpomInput = {
  details: IPOMDetailsInput;
  visitId: Scalars['String']['input'];
};

export type CreateProcedureInput = {
  createdOnVisitId?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['String']['input'];
  type: ProcedureType;
};

export type Ct = BaseVital & Global & {
  __typename?: 'Ct';
  createdAt: Time;
  customDate?: Maybe<Time>;
  delivered?: Maybe<Time>;
  doctor?: Maybe<Doctor>;
  doctorId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  measured?: Maybe<Time>;
  message?: Maybe<Message>;
  messageId: Scalars['String']['output'];
  overrideFiles?: Maybe<Array<Scalars['String']['output']>>;
  patient?: Maybe<Patient>;
  patientId: Scalars['String']['output'];
  type: VitalType;
  updatedAt: Time;
  visit?: Maybe<Visit>;
  visitId: Scalars['String']['output'];
};

export type CustomerComplaintPaymentInfo = {
  __typename?: 'CustomerComplaintPaymentInfo';
  comment: Scalars['String']['output'];
};

export type CustomerComplaintPaymentInfoInput = {
  comment: Scalars['String']['input'];
};

export type Declaration = {
  __typename?: 'Declaration';
  comment?: Maybe<Scalars['String']['output']>;
  date: Scalars['String']['output'];
  files?: Maybe<Array<Scalars['String']['output']>>;
  genre?: Maybe<DeclarationGenre>;
  npwz?: Maybe<Scalars['String']['output']>;
  patientData?: Maybe<PatientData>;
  type?: Maybe<DeclarationType>;
};

export type DeclarationAcceptedEvent = NfzEventWithVojevodship & {
  __typename?: 'DeclarationAcceptedEvent';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  vojevodship: OrganizationIdVojevodship;
};

export type DeclarationGenerationParams = {
  __typename?: 'DeclarationGenerationParams';
  anotherProviderReason?: Maybe<Scalars['String']['output']>;
  frequentFacilityChangeReason?: Maybe<FrequentFacilityChangeReason>;
};

export type DeclarationGenre =
  | 'DOCTOR'
  | 'NURSE';

export type DeclarationMarketingSource =
  | 'APP'
  | 'EMPTY'
  | 'EPUAP'
  | 'IKP'
  | 'PAPERFIRSTVISIT'
  | 'PAPERORGANIC'
  | 'PAPERSPECIAL';

export type DeclarationNoLongerValidEvent = NfzEventWithVojevodship & {
  __typename?: 'DeclarationNoLongerValidEvent';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  reason: DeclarationNoLongerValidReason;
  vojevodship: OrganizationIdVojevodship;
};

export type DeclarationNoLongerValidReason = FacilityChangeEvent | IncorrectDeclarationEvent | PatientDiedEvent;

export type DeclarationRejectedEvent = NfzEventWithVojevodship & {
  __typename?: 'DeclarationRejectedEvent';
  createdAt: Scalars['DateTime']['output'];
  exactRejectionReason: Scalars['String']['output'];
  id: Scalars['String']['output'];
  nfzComment: Scalars['String']['output'];
  rejectionReason: DeclarationRejectionReason;
  vojevodship: OrganizationIdVojevodship;
};

export type DeclarationRejectionReason =
  | 'NOT_INSURED';

export type DeclarationSource =
  | 'APP'
  | 'EPUAP'
  | 'IKP'
  | 'PAPER';

export type DeclarationSubmittedEvent = NfzEventWithVojevodship & {
  __typename?: 'DeclarationSubmittedEvent';
  comment: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  declarationGenerationParams: DeclarationGenerationParams;
  declarationUploadStaff?: Maybe<Doctor>;
  declarationUploadedBy?: Maybe<Scalars['String']['output']>;
  doctor: Doctor;
  filename: Scalars['String']['output'];
  files: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isElectronicallySigned: Scalars['Boolean']['output'];
  marketingSource: DeclarationMarketingSource;
  signature: Scalars['String']['output'];
  source: DeclarationSource;
  vojevodship: OrganizationIdVojevodship;
};

export type DeclarationType =
  | 'APP'
  | 'EPUAP'
  | 'IKP'
  | 'PAPER';

export type Diag = {
  __typename?: 'Diag';
  commission?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  isAvailableAsNFZ: Scalars['Boolean']['output'];
  isAvailableAsNFZForNurse: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  orgIds?: Maybe<Array<Scalars['String']['output']>>;
  price: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export type DiagOrPacket = Diag | DiagPacket;

export type DiagPacket = {
  __typename?: 'DiagPacket';
  items: Array<Diag>;
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
};

export type Diagnosis = {
  __typename?: 'Diagnosis';
  code?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<DiagnosisGrade>;
};

export type DiagnosisGrade =
  | 'MAIN'
  | 'SUPPLEMENTARY';

export type DiagnosisInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<DiagnosisGrade>;
};

export type DietInput = {
  date?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type DietIpom = {
  __typename?: 'DietIpom';
  date?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type Doctor = BaseUser & Global & {
  __typename?: 'Doctor';
  about?: Maybe<Scalars['String']['output']>;
  adultDeclarable: Scalars['Boolean']['output'];
  adultsAvailable?: Maybe<Scalars['Boolean']['output']>;
  avatar: Scalars['String']['output'];
  childrenAvailable?: Maybe<Scalars['Boolean']['output']>;
  childrenDeclarable: Scalars['Boolean']['output'];
  consultantInfo: Scalars['JSON']['output'];
  createdAt: Time;
  declaringToOrganizationId?: Maybe<Scalars['String']['output']>;
  ekgCertification: Scalars['Boolean']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  genre: UserGenre;
  hasPassword?: Maybe<Scalars['Boolean']['output']>;
  hiddenSnippets?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  intercomUserHash: Scalars['String']['output'];
  isDeclarable?: Maybe<Scalars['Boolean']['output']>;
  lastLogin: Time;
  lastName?: Maybe<Scalars['String']['output']>;
  medicalPushToken?: Maybe<Scalars['JSON']['output']>;
  npwz?: Maybe<Scalars['String']['output']>;
  passwordHash: Scalars['String']['output'];
  pesel?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  realNFZStatus: RealNFZStatusType;
  referralCommissionSum: Scalars['Float']['output'];
  seenPosts: Array<Scalars['String']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
  sipNumber?: Maybe<Scalars['String']['output']>;
  snippets?: Maybe<Array<SnippetEntity>>;
  terms?: Maybe<Array<Term>>;
  updatedAt: Time;
};

export type DoctorAdviceInput = {
  doctorInterview?: InputMaybe<Scalars['String']['input']>;
  physicalExamination?: InputMaybe<Scalars['String']['input']>;
  recommendation?: InputMaybe<Scalars['String']['input']>;
};

export type DoctorInput = {
  hiddenSnippets?: InputMaybe<Array<Scalars['String']['input']>>;
  medicalPushToken?: InputMaybe<Scalars['JSON']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  signature?: InputMaybe<Scalars['String']['input']>;
  zusCert?: InputMaybe<Scalars['String']['input']>;
  zusPass?: InputMaybe<Scalars['String']['input']>;
};

export type DoctorInterval = {
  __typename?: 'DoctorInterval';
  max: Scalars['String']['output'];
  min: Scalars['String']['output'];
};

export type DoctorWithSecrets = BaseUser & Global & {
  __typename?: 'DoctorWithSecrets';
  about?: Maybe<Scalars['String']['output']>;
  adultDeclarable: Scalars['Boolean']['output'];
  adultsAvailable?: Maybe<Scalars['Boolean']['output']>;
  avatar: Scalars['String']['output'];
  childrenAvailable?: Maybe<Scalars['Boolean']['output']>;
  childrenDeclarable: Scalars['Boolean']['output'];
  consultantInfo: Scalars['JSON']['output'];
  createdAt: Time;
  declaringToOrganizationId?: Maybe<Scalars['String']['output']>;
  ekgCertification: Scalars['Boolean']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  genre: UserGenre;
  hasPassword?: Maybe<Scalars['Boolean']['output']>;
  hiddenSnippets?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  intercomUserHash: Scalars['String']['output'];
  isDeclarable?: Maybe<Scalars['Boolean']['output']>;
  lastLogin: Time;
  lastName?: Maybe<Scalars['String']['output']>;
  medicalPushToken?: Maybe<Scalars['JSON']['output']>;
  npwz?: Maybe<Scalars['String']['output']>;
  passwordHash: Scalars['String']['output'];
  pesel?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  realNFZStatus: RealNFZStatusType;
  referralCommissionSum: Scalars['Float']['output'];
  seenPosts: Array<Scalars['String']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
  sipNumber?: Maybe<Scalars['String']['output']>;
  sipNumberRecording?: Maybe<Scalars['String']['output']>;
  sipUserId?: Maybe<Scalars['String']['output']>;
  sipUserIdRecording?: Maybe<Scalars['String']['output']>;
  sipUserPassword?: Maybe<Scalars['String']['output']>;
  sipUserPasswordRecording?: Maybe<Scalars['String']['output']>;
  snippets?: Maybe<Array<SnippetEntity>>;
  terms?: Maybe<Array<Term>>;
  updatedAt: Time;
};

export type DocumentGenerationResult = {
  __typename?: 'DocumentGenerationResult';
  documentId: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
};

export type DosagePeriod = {
  days: Scalars['Int']['input'];
  dosage: Array<Scalars['String']['input']>;
};

export type Drug = {
  __typename?: 'Drug';
  activeSubstances?: Maybe<Array<Maybe<ActiveSubstance>>>;
  additionalPermission?: Maybe<Scalars['String']['output']>;
  boxAmount?: Maybe<Scalars['Int']['output']>;
  cost: Scalars['String']['output'];
  dose: Scalars['String']['output'];
  drug: Scalars['String']['output'];
  drugAmount?: Maybe<Scalars['Float']['output']>;
  ean?: Maybe<Scalars['String']['output']>;
  form: Scalars['String']['output'];
  hourInterval?: Maybe<Scalars['Int']['output']>;
  interval?: Maybe<Scalars['String']['output']>;
  morePatientInfo?: Maybe<Scalars['String']['output']>;
  morePharmacistInfo?: Maybe<Scalars['String']['output']>;
  package?: Maybe<Scalars['String']['output']>;
  psychoSubstances?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use package field */
  quantity?: Maybe<Scalars['String']['output']>;
  quantityDescription?: Maybe<Scalars['String']['output']>;
  recipeId?: Maybe<Scalars['Int']['output']>;
};

export type DrugDetails = {
  __typename?: 'DrugDetails';
  activeSubstances: Array<ActiveSubstanceOfDrug>;
  additionalRefunds: Array<AdditionalRefundRight>;
  box: Scalars['String']['output'];
  comments?: Maybe<Scalars['String']['output']>;
  composition?: Maybe<Scalars['String']['output']>;
  continuation?: Maybe<Scalars['Boolean']['output']>;
  contraindications?: Maybe<Scalars['String']['output']>;
  dosage: Scalars['String']['output'];
  dosageDescription?: Maybe<Scalars['String']['output']>;
  drugStatus?: Maybe<Scalars['String']['output']>;
  ean: Scalars['String']['output'];
  effect?: Maybe<Scalars['String']['output']>;
  form: Scalars['String']['output'];
  hasPsychoSubstances: Scalars['Boolean']['output'];
  indications?: Maybe<Scalars['String']['output']>;
  interactions?: Maybe<Scalars['String']['output']>;
  isCustom: Scalars['Boolean']['output'];
  isWithdrawed?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  paymentLevels: Array<PaymentDetails>;
  precautions?: Maybe<Scalars['String']['output']>;
  pregnacyDetails: PregnacyDetails;
  pregnantWomenInstructions?: Maybe<Scalars['String']['output']>;
  productCharacteristics?: Maybe<Scalars['String']['output']>;
  selfAdministration?: Maybe<Scalars['Boolean']['output']>;
  use?: Maybe<Scalars['String']['output']>;
};

export type DrugMaterial = {
  __typename?: 'DrugMaterial';
  dose: Scalars['String']['output'];
  doseInfo: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  sort: Scalars['String']['output'];
  unit: Scalars['String']['output'];
};

export type DrugRecipe = {
  __typename?: 'DrugRecipe';
  description: Scalars['String']['output'];
  dose: Scalars['String']['output'];
  form: Scalars['String']['output'];
  formDescription: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  materials: Array<DrugMaterial>;
  name: Scalars['String']['output'];
  quantityDescription: Scalars['String']['output'];
};

export type DrugWithPackageInput = {
  box: Scalars['String']['input'];
  boxAmount: Scalars['Int']['input'];
  dose: Scalars['String']['input'];
  dosingPeriod?: InputMaybe<Scalars['Int']['input']>;
  ean: Scalars['String']['input'];
  enableSelfOrdinationForMonths?: InputMaybe<Scalars['Float']['input']>;
  form: Scalars['String']['input'];
  interval: Scalars['String']['input'];
  name: Scalars['String']['input'];
  payment: Scalars['String']['input'];
  periods?: InputMaybe<Array<DosagePeriod>>;
  psychoSubstances: Scalars['Boolean']['input'];
};

export type DynamicPositionData = {
  __typename?: 'DynamicPositionData';
  color: Scalars['String']['output'];
  material: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type Ecommerce = BaseVital & Global & {
  __typename?: 'Ecommerce';
  createdAt: Time;
  customComment?: Maybe<Scalars['String']['output']>;
  customDate?: Maybe<Time>;
  customName?: Maybe<Scalars['String']['output']>;
  delivered?: Maybe<Time>;
  doctor?: Maybe<Doctor>;
  doctorId: Scalars['String']['output'];
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  measured?: Maybe<Time>;
  message?: Maybe<Message>;
  messageId: Scalars['String']['output'];
  overrideFiles?: Maybe<Array<Scalars['String']['output']>>;
  patient?: Maybe<Patient>;
  patientId: Scalars['String']['output'];
  type: VitalType;
  updatedAt: Time;
  visit?: Maybe<Visit>;
  visitId: Scalars['String']['output'];
};

export type Ekg = BaseVital & Global & {
  __typename?: 'Ekg';
  comments?: Maybe<Scalars['String']['output']>;
  createdAt: Time;
  customDate?: Maybe<Time>;
  delivered?: Maybe<Time>;
  doctor?: Maybe<Doctor>;
  doctorId: Scalars['String']['output'];
  file?: Maybe<Scalars['String']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  measured?: Maybe<Time>;
  message?: Maybe<Message>;
  messageId: Scalars['String']['output'];
  overrideFiles?: Maybe<Array<Scalars['String']['output']>>;
  patient?: Maybe<Patient>;
  patientId: Scalars['String']['output'];
  type: VitalType;
  updatedAt: Time;
  visit?: Maybe<Visit>;
  visitId: Scalars['String']['output'];
};

export type EkgResults = {
  __typename?: 'EkgResults';
  date: Scalars['String']['output'];
  link: Scalars['String']['output'];
};

export type EmployeeBenefitPaymentMethodInfo = {
  __typename?: 'EmployeeBenefitPaymentMethodInfo';
  benefit: Scalars['String']['output'];
};

export type EmployeeBenefitPaymentMethodInfoInput = {
  benefit: Scalars['String']['input'];
};

export type EwusCheck = {
  __typename?: 'EwusCheck';
  checker?: Maybe<Checker>;
  date: Scalars['String']['output'];
  status: EwusCheckStatus;
};

export type EwusCheckEvent = NfzEventBase & {
  __typename?: 'EwusCheckEvent';
  createdAt: Scalars['DateTime']['output'];
  event: EwusEvent;
  id: Scalars['String']['output'];
};

export type EwusCheckStatus =
  | 'INSURED'
  | 'SIGNED_TODAY'
  | 'UNINSURED';

export type EwusCheckWithDate = {
  __typename?: 'EwusCheckWithDate';
  date: Scalars['String']['output'];
  status: NFZEventType;
};

export type EwusEvent = EwusGreenEvent | EwusRedEvent;

export type EwusGreenEvent = NfzEventBase & {
  __typename?: 'EwusGreenEvent';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
};

export type EwusRedEvent = NfzEventBase & {
  __typename?: 'EwusRedEvent';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
};

export type ExactInsuranceStatus = EwusCheckEvent | InsuranceContributionCertificateEvent | PatientInsuranceStatementEvent;

export type ExpectedDateOfBirthInput = {
  expectedDateOfBirth: Scalars['DateTime']['input'];
};

export type FacilityChangeEvent = NfzEventWithVojevodship & {
  __typename?: 'FacilityChangeEvent';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  info: FacilityChangeInfo;
  vojevodship: OrganizationIdVojevodship;
};

export type FacilityChangeInVoivodeshipEvent = NfzEventWithVojevodship & {
  __typename?: 'FacilityChangeInVoivodeshipEvent';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  nfzComment: Scalars['String']['output'];
  vojevodship: OrganizationIdVojevodship;
};

export type FacilityChangeInfo = FacilityChangeInVoivodeshipEvent | FacilityChangeOutsideVoivodeshipEvent;

export type FacilityChangeOutsideVoivodeshipEvent = NfzEventWithVojevodship & {
  __typename?: 'FacilityChangeOutsideVoivodeshipEvent';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  insuranceProviderInfo: Scalars['String']['output'];
  insuranceProviderInfoUrl: Scalars['String']['output'];
  nfzComment: Scalars['String']['output'];
  vojevodship: OrganizationIdVojevodship;
};

export type FaqType =
  | 'BLOOD'
  | 'DRUGPASS'
  | 'EKG'
  | 'MEDICINE'
  | 'OGTT'
  | 'POO'
  | 'RTG'
  | 'SPIRO'
  | 'STANDARD'
  | 'URINE_CULTURE'
  | 'URINE_GENERAL'
  | 'USG'
  | 'VACCINE';

export type FinancingSource =
  | 'NFZ'
  | 'commercial'
  | 'public';

export type ForceVisitInput = {
  doctorId: Scalars['String']['input'];
  duration: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
  plannedStart: Scalars['DateTime']['input'];
  serviceCode?: InputMaybe<Scalars['String']['input']>;
  slotType: SlotType;
  type?: InputMaybe<VisitType>;
};

export type ForceVisitInput2 = {
  doctorId: Scalars['String']['input'];
  duration: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
  plannedStart: Scalars['DateTime']['input'];
  serviceCode?: InputMaybe<Scalars['String']['input']>;
  visitType: PShiftVisitType;
};

export type FreeTime = {
  __typename?: 'FreeTime';
  doctor: Doctor;
  doctorLanguages: Array<SupportedLanguage>;
  location: Scalars['String']['output'];
  organization_id?: Maybe<Scalars['String']['output']>;
  place: Scalars['String']['output'];
  slot_id: Scalars['Int']['output'];
  time: Scalars['String']['output'];
};

export type FrequentFacilityChangeReason =
  | 'ANOTHER_FACT'
  | 'ANOTHER_PROVIDER_REASON'
  | 'CHANGE_OF_ADDRESS_OF_RESIDENCE'
  | 'REACHING_ADULTHOOD_WITH_PEDIATRICIAN'
  | 'SERVICE_PROVIDER_CEASING';

export type FullAddress = {
  __typename?: 'FullAddress';
  city: Scalars['String']['output'];
  flatNumber?: Maybe<Scalars['String']['output']>;
  houseNumber: Scalars['String']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  municipality?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street: Scalars['String']['output'];
  teryt?: Maybe<Scalars['String']['output']>;
  zipCode: Scalars['String']['output'];
};

export type GetMedicalLeavesInput = {
  pesel: Scalars['String']['input'];
};

export type GetZusPayersByNIPInput = {
  nip: Scalars['String']['input'];
};

export type GetZusPayersInput = {
  passportCode?: InputMaybe<Scalars['String']['input']>;
  pesel: Scalars['String']['input'];
};

export type Global = {
  createdAt: Time;
  updatedAt: Time;
};

export type Heartrate = BaseVital & Global & {
  __typename?: 'Heartrate';
  createdAt: Time;
  customDate?: Maybe<Time>;
  delivered?: Maybe<Time>;
  doctor?: Maybe<Doctor>;
  doctorId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  measured?: Maybe<Time>;
  message?: Maybe<Message>;
  messageId: Scalars['String']['output'];
  overrideFiles?: Maybe<Array<Scalars['String']['output']>>;
  patient?: Maybe<Patient>;
  patientId: Scalars['String']['output'];
  rate: Scalars['Int']['output'];
  type: VitalType;
  updatedAt: Time;
  visit?: Maybe<Visit>;
  visitId: Scalars['String']['output'];
};

export type History = {
  __typename?: 'History';
  change: Scalars['JSON']['output'];
  user: User;
  userId: Scalars['String']['output'];
  when: Time;
};

export type ICD9Input = {
  icd9: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type ICD9IpomInput = {
  icd9: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type ICD9Main = {
  __typename?: 'ICD9Main';
  icd9: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ICD10Input = {
  icd10: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type ICD10Main = {
  __typename?: 'ICD10Main';
  icd10: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type IPOMDetailsInput = {
  additionalInformation?: InputMaybe<Scalars['String']['input']>;
  controlVisits: Array<ControlVisitInput>;
  diet?: InputMaybe<Array<DietInput>>;
  levelStratification: LevelStratification;
  medicines?: InputMaybe<Array<MedicineInput>>;
  nurse?: InputMaybe<Array<NurseInput>>;
  observations: Array<ObservationInput>;
  otherAdvice?: InputMaybe<Scalars['String']['input']>;
  scheduledDiagnosticTests?: InputMaybe<Array<ScheduledDiagnosticTestInput>>;
  specialistConsultations?: InputMaybe<Array<JmIpomVisitType>>;
  specialistVisits?: InputMaybe<Array<JmIpomVisitType>>;
  summary: Scalars['String']['input'];
};

export type ImmuCalendarOutput = {
  __typename?: 'ImmuCalendarOutput';
  name: Scalars['String']['output'];
  shouldBeDone: Scalars['Boolean']['output'];
};

export type InabilityToWorkInput = {
  inabilityToWorkSince: Scalars['DateTime']['input'];
  inabilityToWorkUntil: Scalars['DateTime']['input'];
};

export type IncorrectDeclarationEvent = NfzEventWithVojevodship & {
  __typename?: 'IncorrectDeclarationEvent';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  vojevodship: OrganizationIdVojevodship;
};

export type Injection = BaseVital & Global & {
  __typename?: 'Injection';
  closed: Scalars['Boolean']['output'];
  comments?: Maybe<Scalars['String']['output']>;
  createdAt: Time;
  customDate?: Maybe<Time>;
  delivered?: Maybe<Time>;
  doctor?: Maybe<Doctor>;
  doctorId: Scalars['String']['output'];
  drugs: Array<InjectionDrug>;
  id: Scalars['String']['output'];
  injectionType: InjectionType;
  measured?: Maybe<Time>;
  message?: Maybe<Message>;
  messageId: Scalars['String']['output'];
  overrideFiles?: Maybe<Array<Scalars['String']['output']>>;
  patient?: Maybe<Patient>;
  patientId: Scalars['String']['output'];
  patientSignatureAgreement: Scalars['String']['output'];
  patientSignatureTransport: Scalars['String']['output'];
  portions: Scalars['String']['output'];
  type: VitalType;
  updatedAt: Time;
  visit?: Maybe<Visit>;
  visitId: Scalars['String']['output'];
};

export type InjectionDrug = {
  __typename?: 'InjectionDrug';
  date: Scalars['String']['output'];
  name: Scalars['String']['output'];
  series: Scalars['String']['output'];
};

export type InjectionType =
  | 'MEDICINE'
  | 'VACCINE';

export type InsuranceContributionCertificateEvent = NfzEventBase & {
  __typename?: 'InsuranceContributionCertificateEvent';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
};

export type InsuranceStatementData = {
  patientStatement?: InputMaybe<PatientInsuranceStatementData>;
  representativeStatement?: InputMaybe<RepresentativeInsuranceStatementData>;
};

export type InsuranceStatementPatientReason =
  | 'ART_2_UST_1_PKT_4_LIT_A'
  | 'ART_2_UST_1_PKT_4_LIT_B'
  | 'ART_54_UST_1'
  | 'ART_67_UST_4_7'
  | 'OBJECIE_UBEZPIECZENIEM_ZDROWOTNYM_W_RZECZYPOSPOLITEJ_POLSKIEJ'
  | 'UA';

export type InsuranceStatementRepresentativeReason =
  | 'ART_2_UST_1_PKT_3_LIT_A'
  | 'ART_2_UST_1_PKT_3_LIT_B'
  | 'ART_2_UST_1_PKT_3_LIT_C'
  | 'ART_2_UST_1_PKT_4_LIT_A'
  | 'ART_2_UST_1_PKT_4_LIT_B'
  | 'ART_54_UST_1'
  | 'ART_67_UST_4_7'
  | 'OBJECIE_UBEZPIECZENIEM_ZDROWOTNYM_W_RZECZYPOSPOLITEJ_POLSKIEJ'
  | 'UA';

export type InsuranceStatusEvent = NfzEventBase & {
  __typename?: 'InsuranceStatusEvent';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  status: ExactInsuranceStatus;
};

export type Ipom = BaseMessage & Global & {
  __typename?: 'Ipom';
  assignmentType: Scalars['String']['output'];
  createdAt: Time;
  data: Scalars['JSON']['output'];
  doctorId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  patient: Patient;
  patientId: Scalars['String']['output'];
  stripeSessionId: Scalars['String']['output'];
  type: MessageType;
  updatedAt: Time;
  visit: Visit;
  visitId: Scalars['String']['output'];
};

export type IpomProcedureAssignmentInput = {
  assignmentType: Scalars['String']['input'];
  data: IpomProcedureDataInput;
  visitId: Scalars['String']['input'];
};

export type IpomProcedureDataInput = {
  cito: Scalars['Boolean']['input'];
  comment: Scalars['String']['input'];
  icd9: ICD9IpomInput;
};

/** Typ czasu IPOM */
export type IpomTimeType =
  /** Badanie ma być wykonane w określonym czasie po wizycie */
  | 'CZASPOWIZ'
  /** Badanie ma być przeprowadzone w określonym czasie przed wizytą */
  | 'CZASPRZEDWIZ'
  /** Działanie powinno być zakończone do określonej daty */
  | 'DOCZASU'
  /** Okresowe wykonywanie czynności */
  | 'INTERWAL'
  /** Wykonanie w możliwie najszybszym czasie */
  | 'NAJSZYB'
  /** Wykonanie w określonym czasie po zakończeniu terapii lub zdarzeniu */
  | 'POOKRCZASIE'
  /** Wykonanie po zakończeniu leczenia lub wynikach innych badań */
  | 'POWYKZLECZADAN'
  /** Badanie należy wykonać przed zaplanowaną wizytą */
  | 'PRZEDNASTWIZ';

/** Jednostka czasu IPOM */
export type IpomTimeUnit =
  /** Dni */
  | 'DAYS'
  /** Miesiące */
  | 'MONTHS'
  /** Tygodnie */
  | 'WEEKS'
  /** Lata */
  | 'YEARS';

export type IssueMedicalOrCareLeaveResult = {
  __typename?: 'IssueMedicalOrCareLeaveResult';
  leaves: Array<LeavesResult>;
  messageId: Scalars['String']['output'];
};

export type IssuePrescriptionInput = {
  additionalRefundRight?: InputMaybe<AdditionalRefundRight>;
  drugs: Array<DrugWithPackageInput>;
  insuredIn: StateInsurance;
  useSince: Scalars['String']['input'];
  visitId: Scalars['String']['input'];
};

export type IssuePrescriptionWithOperationResult = {
  __typename?: 'IssuePrescriptionWithOperationResult';
  operationIsSafe: Scalars['Boolean']['output'];
  prescriptions: Array<PrescriptionResult>;
};

export type IssueReferralInput = {
  adviceGoal?: InputMaybe<Scalars['String']['input']>;
  clinic: ClinicInput;
  comment?: InputMaybe<Scalars['String']['input']>;
  examinationType?: InputMaybe<Scalars['String']['input']>;
  icd9?: InputMaybe<ICD9Input>;
  icd10: ICD10Input;
  insuredIn?: InputMaybe<StateInsurance>;
  nfzDepartment?: InputMaybe<NfzDepartmentInput>;
  referralType: Scalars['String']['input'];
  urgent: Scalars['Boolean']['input'];
  visitId: Scalars['String']['input'];
};

/** Rodzaje wizyt IPOM */
export type JmIpomVisitType =
  | 'ALERGOLOG'
  | 'DIABETOLOG'
  | 'ENDOKRYNOLOG'
  | 'KARDIOLOG'
  | 'NEFROLOG'
  | 'PULMONOLOG';

export type KeyValue = {
  __typename?: 'KeyValue';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type LabExamEcommerceSource = {
  __typename?: 'LabExamEcommerceSource';
  orderId: Scalars['String']['output'];
  packetInfo?: Maybe<LabExamPacketInfo>;
  saleorProductId?: Maybe<Scalars['String']['output']>;
};

export type LabExamInput = {
  params: Array<VitalParamInput>;
  serviceId: Scalars['String']['input'];
};

export type LabExamPacketInfo = {
  __typename?: 'LabExamPacketInfo';
  discount?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  saleorProductId: Scalars['String']['output'];
  totalPrice?: Maybe<Scalars['Float']['output']>;
};

export type LabExamSource =
  | 'ECOMMERCE'
  | 'PATHWAYS';

export type LabExamSourceInfo = {
  __typename?: 'LabExamSourceInfo';
  ecommerce?: Maybe<LabExamEcommerceSource>;
  pathwayRun?: Maybe<PathwayRun>;
  source: LabExamSource;
};

export type LabExamTemplate = {
  __typename?: 'LabExamTemplate';
  assignment: AssignmentEntity;
  params?: Maybe<Array<VitalParam>>;
};

export type LabExaminationPayment =
  | 'FREE'
  | 'PAID'
  | 'UNPAID';

export type LaboratoryExaminationCreationInput = {
  cito: Scalars['Boolean']['input'];
  createdOnVisitId?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['String']['input'];
  payment: LabExaminationPayment;
  serviceId: Scalars['String']['input'];
};

export type LaboratoryExaminationEntity = {
  __typename?: 'LaboratoryExaminationEntity';
  assignment: Scalars['JSON']['output'];
  cancelled: Scalars['Boolean']['output'];
  cito: Scalars['Boolean']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdOnVisitId?: Maybe<Scalars['String']['output']>;
  creator: User;
  diag: AssignmentEntity;
  diagIdPosition: Scalars['Float']['output'];
  displayPayment: Scalars['String']['output'];
  executionLimit: Scalars['String']['output'];
  groupId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  paidFromEntrustedBudget: Scalars['Boolean']['output'];
  patient: UserEntity;
  patientId: Scalars['String']['output'];
  payment: LabExaminationPayment;
  paymentId?: Maybe<Scalars['String']['output']>;
  paymentLog?: Maybe<PaymentLogEntity>;
  paymentLogId?: Maybe<Scalars['String']['output']>;
  price: Scalars['String']['output'];
  sampleId?: Maybe<Scalars['String']['output']>;
  serviceId: Scalars['String']['output'];
  sourceInfo?: Maybe<LabExamSourceInfo>;
  stripeSessionId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  visit?: Maybe<Visit>;
  visitId?: Maybe<Scalars['String']['output']>;
};

export type LaboratoryExaminationUpdateDataInput = {
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  cito?: InputMaybe<Scalars['Boolean']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  payment?: InputMaybe<LabExaminationPayment>;
  sampleId?: InputMaybe<Scalars['String']['input']>;
  visitId?: InputMaybe<Scalars['String']['input']>;
};

export type LastDayOfWorkInput = {
  lastDayOfWork: Scalars['DateTime']['input'];
};

export type Leave = BaseMessage & Global & {
  __typename?: 'Leave';
  careSince?: Maybe<Scalars['String']['output']>;
  careUntil?: Maybe<Scalars['String']['output']>;
  codes?: Maybe<Codes>;
  createdAt: Time;
  doNotSendPayerInfo?: Maybe<Scalars['Boolean']['output']>;
  doctor: Doctor;
  doctorId: Scalars['String']['output'];
  icd10Main: ICD10Main;
  id: Scalars['String']['output'];
  inabilitySince?: Maybe<Scalars['String']['output']>;
  inabilityUntil?: Maybe<Scalars['String']['output']>;
  insuredIn?: Maybe<Scalars['String']['output']>;
  leaveType?: Maybe<Scalars['String']['output']>;
  leaves?: Maybe<Array<LeaveDetails>>;
  patient: Patient;
  patientId: Scalars['String']['output'];
  payer?: Maybe<Payer>;
  payers?: Maybe<Array<Payer>>;
  reason?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['String']['output']>;
  stripeSessionId: Scalars['String']['output'];
  type: MessageType;
  underCarePerson?: Maybe<UnderCarePerson>;
  updatedAt: Time;
  visit: Visit;
  visitId: Scalars['String']['output'];
};

export type LeaveAddress = {
  __typename?: 'LeaveAddress';
  city: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  flatNumber?: Maybe<Scalars['String']['output']>;
  houseNumber: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  street: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type LeaveDetails = {
  __typename?: 'LeaveDetails';
  address?: Maybe<LeaveAddress>;
  guardian?: Maybe<LeaveGuardian>;
  ids: Array<Scalars['String']['output']>;
  seriesNumber: Scalars['String']['output'];
  upo: Array<Scalars['String']['output']>;
};

export type LeaveGuardian = {
  __typename?: 'LeaveGuardian';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  pesel: Scalars['String']['output'];
};

export type LeavesResult = {
  __typename?: 'LeavesResult';
  ids: Array<Scalars['String']['output']>;
  seriesNumber: Scalars['String']['output'];
  upo: Scalars['String']['output'];
};

/** Poziom stratyfikacji */
export type LevelStratification =
  /** Pośredni */
  | 'P'
  /** Stabilny */
  | 'S'
  /** Zagrozony niestabilnością */
  | 'Z';

export type LlmChatMessage = {
  __typename?: 'LlmChatMessage';
  content: Scalars['String']['output'];
  role: Scalars['String']['output'];
};

export type Location = {
  __typename?: 'Location';
  latitude: Scalars['Float']['output'];
  longtitude: Scalars['Float']['output'];
};

export type MeasurementInput = {
  diastolicPressure?: InputMaybe<Scalars['String']['input']>;
  pulse?: InputMaybe<Scalars['String']['input']>;
  resultType?: InputMaybe<Scalars['String']['input']>;
  systolicPressure?: InputMaybe<Scalars['String']['input']>;
};

export type MedicalActInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  diastolicPressure?: InputMaybe<Scalars['String']['input']>;
  glycemia?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['String']['input']>;
  pulse?: InputMaybe<Scalars['String']['input']>;
  systolicPressure?: InputMaybe<Scalars['String']['input']>;
  temperature?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['String']['input']>;
};

export type MedicalDocumentSource =
  | 'CHAT'
  | 'CHAT_LLM'
  | 'DRIVE'
  | 'EKG'
  | 'EMAIL';

export type MedicalLeaveDetails = {
  __typename?: 'MedicalLeaveDetails';
  careSince: Scalars['String']['output'];
  careUntil: Scalars['String']['output'];
  code: Scalars['String']['output'];
  doNotSendPayerInfo: Scalars['Boolean']['output'];
  icd10: ICD10Main;
  inabilitySince: Scalars['String']['output'];
  inabilityUntil: Scalars['String']['output'];
  recommendation: Scalars['String']['output'];
};

export type MedicalLeaveInput = {
  address: StayAddressInput;
  codes: CodesInput;
  doNotSendPayerInfo?: InputMaybe<Scalars['Boolean']['input']>;
  icd10Main: ICD10Input;
  inabilitySince: Scalars['String']['input'];
  inabilityUntil: Scalars['String']['input'];
  insuredIn?: InputMaybe<StateInsurance>;
  leaveType: Scalars['String']['input'];
  outdatedReason?: InputMaybe<Scalars['String']['input']>;
  payers: Array<PayerInput>;
  recommendation: Scalars['String']['input'];
  visitId: Scalars['String']['input'];
};

export type MedicalLeaveInputNew = {
  address: StayAddressInput;
  codes: CodesInput;
  doNotSendPayerInfo?: InputMaybe<Scalars['Boolean']['input']>;
  icd10Main: ICD10Input;
  inabilitySince: Scalars['String']['input'];
  inabilityUntil: Scalars['String']['input'];
  insuredIn?: InputMaybe<StateInsurance>;
  leaveType: Scalars['String']['input'];
  outdatedReason?: InputMaybe<Scalars['String']['input']>;
  payers: Array<PayerInputNew>;
  recommendation: Scalars['String']['input'];
  visitId: Scalars['String']['input'];
};

export type MedicalRecordEntity = {
  __typename?: 'MedicalRecordEntity';
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  fileId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  patientId: Scalars['String']['output'];
  source: MedicalDocumentSource;
  starred: Scalars['Boolean']['output'];
  tagId?: Maybe<Scalars['String']['output']>;
  tidyDocumentationResult?: Maybe<TidyDocumentationResultEntity>;
  tidy_status?: Maybe<Scalars['String']['output']>;
};

export type MedicalServices = {
  __typename?: 'MedicalServices';
  primaryMedicalService?: Maybe<PrimaryMedicalService>;
};

export type MedicalTestimonialInput = {
  attachDiagnosisToTestimonial: Scalars['Boolean']['input'];
  diagnosisICD10?: InputMaybe<Scalars['String']['input']>;
  testimonialGoal: Scalars['String']['input'];
};

export type MedicineInput = {
  dosage: Scalars['String']['input'];
  dose?: InputMaybe<Scalars['String']['input']>;
  ean: Scalars['String']['input'];
  form?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
};

export type MedicineIpom = {
  __typename?: 'MedicineIpom';
  dosage: Scalars['String']['output'];
  dose?: Maybe<Scalars['String']['output']>;
  ean: Scalars['String']['output'];
  form?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  quantity?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
};

export type MedicineSubtitle = {
  __typename?: 'MedicineSubtitle';
  subtitle: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type Message = Assignment | Careleave | Ipom | Leave | Prescription | Referral | Testimonial;

export type MessageType =
  | 'ASSIGNMENT'
  | 'CARELEAVE'
  | 'IPOM'
  | 'LEAVE'
  | 'PRESCRIPTION'
  | 'REFERRAL'
  | 'TESTIMONIAL';

export type MidwifeEducationalVisit = {
  pregnacyWeek?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  visitTopics?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addDeclarationScanToNFZEvent: Scalars['String']['output'];
  addImmunizationCalendar: Scalars['Boolean']['output'];
  archiveDocument: Scalars['String']['output'];
  cancelIpom: Scalars['Boolean']['output'];
  changePassword: Scalars['String']['output'];
  checkPatientEwusStatus: Scalars['String']['output'];
  cleanReports: Scalars['String']['output'];
  closePatient: Patient;
  closeVisit: Visit;
  createAssignment: Scalars['String']['output'];
  createChatMessage: Scalars['String']['output'];
  createCovidExamination: Scalars['String']['output'];
  createDocument: MedicalRecordEntity;
  createIPOM: CreateIPOMWithOperationResult;
  createIpomAssignment: Scalars['String']['output'];
  createLaboratoryExaminations: Array<LaboratoryExaminationEntity>;
  createNFZEvent: Scalars['String']['output'];
  createPatient: Scalars['String']['output'];
  createPatientTag: Scalars['String']['output'];
  createProcedure: ProcedureEntity;
  createProcedureNew: ProcedureEntity;
  createSnippet: Snippet;
  createSurvey: Scalars['String']['output'];
  createVisit: Scalars['String']['output'];
  createVisitSlot: Scalars['String']['output'];
  createVisitSlot2: Scalars['String']['output'];
  createVital: Scalars['String']['output'];
  deleteChatMessage: Scalars['String']['output'];
  deleteNFZEvent: Scalars['String']['output'];
  deletePatient: Scalars['String']['output'];
  deletePatientTag: Scalars['String']['output'];
  deletePrescription: Scalars['String']['output'];
  deleteSnippet: Snippet;
  deleteTestimonial: Scalars['String']['output'];
  deleteVisit: Visit;
  deleteVisit2: Visit;
  deleteVisitSpecialistSlot: Scalars['String']['output'];
  deleteVital: Scalars['String']['output'];
  forceCreateVisit: Visit;
  forceCreateVisit2: Visit;
  forceVisit: Visit;
  forceVisit2: Visit;
  generateDeclaration: DocumentGenerationResult;
  generateIpomPdfDocument: DocumentGenerationResult;
  generateTestimonial: DocumentGenerationResult;
  generateUsgResultsDocument: DocumentGenerationResult;
  getContentFromImage: Scalars['String']['output'];
  /** Returns null if there is no requests, try to refresh count of requests and try again */
  getOnePrescriptionRequest?: Maybe<Visit>;
  getOpenPrescriptionVisits: Array<Visit>;
  issueCareLeave: IssueMedicalOrCareLeaveResult;
  issueMedicalLeave: Scalars['String']['output'];
  issueMedicalLeaveNew: IssueMedicalOrCareLeaveResult;
  issueNursePrescription: IssuePrescriptionWithOperationResult;
  issuePrescription: IssuePrescriptionWithOperationResult;
  issueReferral: Scalars['String']['output'];
  loadUMX: Scalars['String']['output'];
  logPayment: Scalars['String']['output'];
  makeCall: Scalars['JSON']['output'];
  markPostsAsSeen: Array<Scalars['String']['output']>;
  patientLeftVisit: Visit;
  patientShowedUpForAVisit: Visit;
  publishTimeEntries: Scalars['Int']['output'];
  pushNFZStatusToFirebase: Scalars['String']['output'];
  pushNFZStatusesToFirebase: Array<Scalars['String']['output']>;
  refreshToken: TokensPayload;
  refreshVaccinations: Scalars['String']['output'];
  reopenVisit: Scalars['String']['output'];
  reportPrepare: Scalars['String']['output'];
  revokeAssignment: Scalars['String']['output'];
  saveHealthInsuranceStatement: Scalars['String']['output'];
  sendInvitationForVisit: Scalars['String']['output'];
  sendRecommendation: ChatMessageEntity;
  showSnippet: Doctor;
  simulateLabExamUpload: Scalars['Boolean']['output'];
  startVisit: Visit;
  swiadPrepare: Scalars['String']['output'];
  unpinAllPatients: Scalars['Int']['output'];
  unpinPatient: Patient;
  unpinProcedure: ProcedureEntity;
  updateDeclarationNFZEventComment: Scalars['String']['output'];
  updateDocument: Scalars['String']['output'];
  updateLaboratoryExaminations: Array<Scalars['String']['output']>;
  updateMe: Scalars['String']['output'];
  updatePatient: Scalars['String']['output'];
  updatePatientTag: Scalars['String']['output'];
  updateProcedure: Scalars['String']['output'];
  updateProcedureNew: Scalars['String']['output'];
  updateSnippet: Snippet;
  updateTodo: Scalars['Boolean']['output'];
  updateUserAddress: Patient;
  updateVisit: Scalars['String']['output'];
  updateVisitSlot: Visit;
  updateVisitSlot2: Visit;
  updateVisitSlot2ForMedicalApp: Visit;
  updateVisitSpecialistSlot: Visit;
  updateVital: Scalars['String']['output'];
  upsertShift: Scalars['Int']['output'];
  upsertSingleProcedure: Scalars['String']['output'];
  waitingForPatient: Patient;
};


export type MutationaddDeclarationScanToNFZEventArgs = {
  declarationScanFileId: Scalars['String']['input'];
  eventId: Scalars['String']['input'];
};


export type MutationaddImmunizationCalendarArgs = {
  indicies: Array<Scalars['Int']['input']>;
  patientId: Scalars['String']['input'];
};


export type MutationarchiveDocumentArgs = {
  id: Scalars['String']['input'];
};


export type MutationcancelIpomArgs = {
  patientId: Scalars['String']['input'];
};


export type MutationchangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationcheckPatientEwusStatusArgs = {
  organizationId: Scalars['String']['input'];
  patientId: Scalars['String']['input'];
};


export type MutationcleanReportsArgs = {
  organizationId: Scalars['String']['input'];
  periodSymbol: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type MutationclosePatientArgs = {
  id: Scalars['String']['input'];
};


export type MutationcloseVisitArgs = {
  id: Scalars['String']['input'];
};


export type MutationcreateAssignmentArgs = {
  input: PrescriptionInput;
};


export type MutationcreateChatMessageArgs = {
  id: Scalars['String']['input'];
  input: ChatMessageInput;
  isSystem?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationcreateCovidExaminationArgs = {
  input: CovidExaminationInput;
};


export type MutationcreateDocumentArgs = {
  input: CreateDocumentInput;
};


export type MutationcreateIPOMArgs = {
  input: CreateIpomInput;
};


export type MutationcreateIpomAssignmentArgs = {
  input: IpomProcedureAssignmentInput;
};


export type MutationcreateLaboratoryExaminationsArgs = {
  createMessageOnChat?: InputMaybe<Scalars['Boolean']['input']>;
  data: Array<LaboratoryExaminationCreationInput>;
};


export type MutationcreateNFZEventArgs = {
  input: NFZEventInput;
  representativeId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationcreatePatientArgs = {
  address: PlacematicAddressInput;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  flatNumber?: InputMaybe<Scalars['String']['input']>;
  languages: Array<SupportedLanguage>;
  lastName: Scalars['String']['input'];
  pesel: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};


export type MutationcreatePatientTagArgs = {
  fileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  input: PatientTagInput;
};


export type MutationcreateProcedureArgs = {
  data: CreateProcedureInput;
  dataInput: ProcedureDataInput;
};


export type MutationcreateProcedureNewArgs = {
  data: CreateProcedureInput;
  dataInput: Scalars['JSONObject']['input'];
};


export type MutationcreateSnippetArgs = {
  input: SnippetInput;
};


export type MutationcreateSurveyArgs = {
  input: SurveyProposalInput;
};


export type MutationcreateVisitArgs = {
  input: NewVisitInput;
};


export type MutationcreateVisitSlotArgs = {
  patientId: Scalars['String']['input'];
  serviceCode?: InputMaybe<Scalars['String']['input']>;
  slotIds: Array<Scalars['Int']['input']>;
  slotsInRow?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationcreateVisitSlot2Args = {
  patientId: Scalars['String']['input'];
  serviceCode?: InputMaybe<Scalars['String']['input']>;
  shiftVisitType: PShiftVisitType;
  shiftsSlot: Array<ShiftsSlot>;
};


export type MutationcreateVitalArgs = {
  input: VitalInput;
  specificInput: Scalars['JSON']['input'];
};


export type MutationdeleteChatMessageArgs = {
  id: Scalars['String']['input'];
};


export type MutationdeleteNFZEventArgs = {
  id: Scalars['String']['input'];
};


export type MutationdeletePatientArgs = {
  phone: Scalars['String']['input'];
};


export type MutationdeletePatientTagArgs = {
  id: Scalars['String']['input'];
};


export type MutationdeletePrescriptionArgs = {
  prescriptionId: Scalars['String']['input'];
};


export type MutationdeleteSnippetArgs = {
  id: Scalars['String']['input'];
};


export type MutationdeleteTestimonialArgs = {
  id: Scalars['String']['input'];
};


export type MutationdeleteVisitArgs = {
  id: Scalars['String']['input'];
};


export type MutationdeleteVisit2Args = {
  id: Scalars['String']['input'];
};


export type MutationdeleteVisitSpecialistSlotArgs = {
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationdeleteVitalArgs = {
  id: Scalars['String']['input'];
};


export type MutationforceCreateVisitArgs = {
  input: ForceVisitInput;
  patientId: Scalars['String']['input'];
};


export type MutationforceCreateVisit2Args = {
  input: ForceVisitInput2;
  patientId: Scalars['String']['input'];
};


export type MutationforceVisitArgs = {
  id: Scalars['String']['input'];
  input: ForceVisitInput;
};


export type MutationforceVisit2Args = {
  id: Scalars['String']['input'];
  input: ForceVisitInput2;
};


export type MutationgenerateDeclarationArgs = {
  representativeId?: InputMaybe<Scalars['String']['input']>;
  request: NfzDeclarationInputDoctor;
};


export type MutationgenerateIpomPdfDocumentArgs = {
  patientId: Scalars['String']['input'];
};


export type MutationgenerateTestimonialArgs = {
  request: TestimonialGenerationInput;
};


export type MutationgenerateUsgResultsDocumentArgs = {
  procedureId: Scalars['String']['input'];
};


export type MutationgetContentFromImageArgs = {
  input: OCRImageInput;
};


export type MutationgetOpenPrescriptionVisitsArgs = {
  patientId: Scalars['String']['input'];
};


export type MutationissueCareLeaveArgs = {
  input: CareLeaveInput;
};


export type MutationissueMedicalLeaveArgs = {
  id: Scalars['String']['input'];
  input: MedicalLeaveInput;
};


export type MutationissueMedicalLeaveNewArgs = {
  input: MedicalLeaveInputNew;
};


export type MutationissueNursePrescriptionArgs = {
  input: IssuePrescriptionInput;
};


export type MutationissuePrescriptionArgs = {
  input: IssuePrescriptionInput;
};


export type MutationissueReferralArgs = {
  input: IssueReferralInput;
};


export type MutationloadUMXArgs = {
  organizationId: Scalars['String']['input'];
  umxContent: Scalars['String']['input'];
};


export type MutationlogPaymentArgs = {
  paidIds: Array<Scalars['String']['input']>;
  paymentMethod: PaymentLogEntryInput;
};


export type MutationmakeCallArgs = {
  patientId: Scalars['String']['input'];
};


export type MutationmarkPostsAsSeenArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationpatientLeftVisitArgs = {
  id: Scalars['String']['input'];
};


export type MutationpatientShowedUpForAVisitArgs = {
  id: Scalars['String']['input'];
};


export type MutationpublishTimeEntriesArgs = {
  from: Scalars['String']['input'];
  place_id: Scalars['String']['input'];
  to: Scalars['String']['input'];
};


export type MutationpushNFZStatusToFirebaseArgs = {
  id: Scalars['String']['input'];
};


export type MutationrefreshTokenArgs = {
  data: RTPayload;
};


export type MutationrefreshVaccinationsArgs = {
  patientId: Scalars['String']['input'];
};


export type MutationreopenVisitArgs = {
  id: Scalars['String']['input'];
};


export type MutationreportPrepareArgs = {
  declarationGenre: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  periodSymbol: Scalars['String']['input'];
  realRun: Scalars['Boolean']['input'];
};


export type MutationrevokeAssignmentArgs = {
  id: Scalars['String']['input'];
};


export type MutationsaveHealthInsuranceStatementArgs = {
  data: NFZEventData;
  executionDate?: InputMaybe<Scalars['DateTime']['input']>;
  organizationId: Scalars['String']['input'];
  patientId: Scalars['String']['input'];
};


export type MutationsendInvitationForVisitArgs = {
  id: Scalars['String']['input'];
  type: VisitType;
};


export type MutationsendRecommendationArgs = {
  visitId: Scalars['String']['input'];
};


export type MutationshowSnippetArgs = {
  doctorId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationsimulateLabExamUploadArgs = {
  labExam: LabExamInput;
  visitId: Scalars['String']['input'];
};


export type MutationstartVisitArgs = {
  id: Scalars['String']['input'];
};


export type MutationswiadPrepareArgs = {
  organizationId: Scalars['String']['input'];
  periodSymbol: Scalars['String']['input'];
  realRun: Scalars['Boolean']['input'];
  version: Scalars['String']['input'];
};


export type MutationunpinPatientArgs = {
  id: Scalars['String']['input'];
};


export type MutationunpinProcedureArgs = {
  id: Scalars['String']['input'];
};


export type MutationupdateDeclarationNFZEventCommentArgs = {
  comment: Scalars['String']['input'];
  eventId: Scalars['String']['input'];
};


export type MutationupdateDocumentArgs = {
  id: Scalars['String']['input'];
  input: UpdateDocumentInput;
};


export type MutationupdateLaboratoryExaminationsArgs = {
  data: LaboratoryExaminationUpdateDataInput;
  ids: Array<Scalars['String']['input']>;
};


export type MutationupdateMeArgs = {
  id: Scalars['String']['input'];
  input: DoctorInput;
};


export type MutationupdatePatientArgs = {
  id: Scalars['String']['input'];
  input: PatientInput;
};


export type MutationupdatePatientTagArgs = {
  fileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['String']['input'];
  input: PatientTagInput;
};


export type MutationupdateProcedureArgs = {
  data?: InputMaybe<UpdateProcedureInput>;
  dataInput?: InputMaybe<ProcedureDataInput>;
  procedureId: Scalars['String']['input'];
};


export type MutationupdateProcedureNewArgs = {
  data?: InputMaybe<UpdateProcedureInput>;
  dataInput: Scalars['JSONObject']['input'];
  procedureId: Scalars['String']['input'];
};


export type MutationupdateSnippetArgs = {
  id: Scalars['String']['input'];
  input: SnippetInput;
};


export type MutationupdateTodoArgs = {
  id: Scalars['Int']['input'];
  plannedDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<TodoStatus>;
};


export type MutationupdateUserAddressArgs = {
  address: PlacematicAddressInput;
  flatNumber?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type MutationupdateVisitArgs = {
  id: Scalars['String']['input'];
  input: VisitInput;
};


export type MutationupdateVisitSlotArgs = {
  id: Scalars['String']['input'];
  slotIds: Array<Scalars['Int']['input']>;
  slotsInRow?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationupdateVisitSlot2Args = {
  id: Scalars['String']['input'];
  shiftVisitType?: InputMaybe<PShiftVisitType>;
  shiftsSlot: Array<ShiftsSlot>;
};


export type MutationupdateVisitSlot2ForMedicalAppArgs = {
  id: Scalars['String']['input'];
  shiftsSlot: Array<ShiftsSlot>;
  visitType: PShiftVisitType;
};


export type MutationupdateVisitSpecialistSlotArgs = {
  id: Scalars['String']['input'];
  reservationId?: InputMaybe<Scalars['String']['input']>;
  slotId: Scalars['Int']['input'];
};


export type MutationupdateVitalArgs = {
  id: Scalars['String']['input'];
  specificInput: Scalars['JSON']['input'];
};


export type MutationupsertShiftArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  input: ShiftInput;
};


export type MutationupsertSingleProcedureArgs = {
  data: Scalars['String']['input'];
  procedureType?: InputMaybe<ProcedureType>;
  visitId: Scalars['String']['input'];
};


export type MutationwaitingForPatientArgs = {
  id: Scalars['String']['input'];
};

export type NFZEventData = {
  insuranceStatement?: InputMaybe<InsuranceStatementData>;
  patientId?: InputMaybe<Scalars['String']['input']>;
};

export type NFZEventEntity = {
  __typename?: 'NFZEventEntity';
  data?: Maybe<Scalars['JSON']['output']>;
  employee?: Maybe<StaffEntity>;
  employeeId?: Maybe<Scalars['String']['output']>;
  executionDate: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  patientId: Scalars['String']['output'];
  reportingId: Scalars['Int']['output'];
  type: NFZEventType;
};

export type NFZEventInput = {
  data: Scalars['JSON']['input'];
  executionDate: Scalars['DateTime']['input'];
  organizationId: OrganizationIdVojevodship;
  patientId: Scalars['String']['input'];
  type: NFZEventType;
};

export type NFZEventType =
  | 'DEKLARACJA'
  | 'EWUS_CZERWONY'
  | 'EWUS_UA'
  | 'EWUS_ZIELONY'
  | 'NFZ_AKCEPTACJA'
  | 'NFZ_AKCEPTACJA_PIELEGNIARKA'
  | 'NFZ_AKCEPTACJA_POLOZNA'
  | 'NFZ_ODRZUCENIE'
  | 'NFZ_ODRZUCENIE_PIELEGNIARKA'
  | 'NFZ_ODRZUCENIE_POLOZNA'
  | 'OSWIADCZENIE'
  | 'ZASWIADCZENIE_OD_PLATNIKA_SKLADEK';

export type NewVisitInput = {
  patientId: Scalars['String']['input'];
  type?: InputMaybe<VisitType>;
};

export type NfzDeclarationInputDoctor = {
  anotherProviderReason?: InputMaybe<Scalars['String']['input']>;
  doctorId: Scalars['String']['input'];
  electronicallySignedDocument: Scalars['Boolean']['input'];
  facilityChangeReason?: InputMaybe<FrequentFacilityChangeReason>;
  nurseId: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['String']['input'];
};

export type NfzDeclarationInputPatientMultiple = {
  anotherProviderReason?: InputMaybe<Scalars['String']['input']>;
  electronicallySignedDocument: Scalars['Boolean']['input'];
  facilityChangeReason?: InputMaybe<FrequentFacilityChangeReason>;
  generationDate?: InputMaybe<Scalars['DateTime']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['String']['input'];
  staffId: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type NfzDepartmentInput = {
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type NfzEventBase = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
};

export type NfzEventWithVojevodship = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  vojevodship: OrganizationIdVojevodship;
};

export type NfzHistoryEvent = DeclarationAcceptedEvent | DeclarationNoLongerValidEvent | DeclarationRejectedEvent | DeclarationSubmittedEvent | InsuranceStatusEvent | UnknownEvent;

export type NoShowNotificationAnswer = {
  __typename?: 'NoShowNotificationAnswer';
  value: Scalars['Boolean']['output'];
  when: Scalars['String']['output'];
};

export type NurseAdviceInput = {
  doctorInterview?: InputMaybe<Scalars['String']['input']>;
  physicalExamination?: InputMaybe<Scalars['String']['input']>;
  recommendation?: InputMaybe<Scalars['String']['input']>;
};

export type NurseInput = {
  date?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type NurseIpom = {
  __typename?: 'NurseIpom';
  date?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type OCRImageInput = {
  bottom: Scalars['Float']['input'];
  imageId: Scalars['String']['input'];
  left: Scalars['Float']['input'];
  right: Scalars['Float']['input'];
  top: Scalars['Float']['input'];
};

export type OL9TestimonialInput = {
  attachments: Array<Scalars['String']['input']>;
  canTravel: Scalars['Boolean']['input'];
  currentTreatment: Scalars['String']['input'];
  mainDiagnosisICD10: Scalars['String']['input'];
  prognosis: Scalars['String']['input'];
  secondaryDiagnosisICD10: Array<Scalars['String']['input']>;
};

export type ObjectedNFZStatus = {
  __typename?: 'ObjectedNFZStatus';
  availablePublicPrivateShenanigans: Array<Scalars['String']['output']>;
  canDeclare: Scalars['Boolean']['output'];
  canUsePublicVisits: Scalars['Boolean']['output'];
  chosenDoctor?: Maybe<Scalars['String']['output']>;
  chosenMidwife?: Maybe<Scalars['String']['output']>;
  chosenNurse?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  declaredIn?: Maybe<Scalars['String']['output']>;
  ewusLastCheck?: Maybe<EwusCheckWithDate>;
  noInsurance?: Maybe<Scalars['Boolean']['output']>;
  telezgodaAccepted: Scalars['Boolean']['output'];
  textStatus?: Maybe<Scalars['String']['output']>;
  wasDeclared: Scalars['Boolean']['output'];
  whereCanDeclare?: Maybe<Scalars['String']['output']>;
};

export type ObservationInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ObservationIpom = {
  __typename?: 'ObservationIpom';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type OpeningHours = {
  __typename?: 'OpeningHours';
  openingType: OpeningType;
  /** Present only if openingType === Hours */
  ranges?: Maybe<Array<Range>>;
  weekday: WeekDay;
};

export type OpeningType =
  | 'Hours'
  | 'OnlineOnly'
  | 'Unavailable';

export type Operation = BaseVital & Global & {
  __typename?: 'Operation';
  comments?: Maybe<Scalars['String']['output']>;
  createdAt: Time;
  customDate?: Maybe<Time>;
  delivered?: Maybe<Time>;
  doctor?: Maybe<Doctor>;
  doctorId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  materials: Array<OperationMaterial>;
  measured?: Maybe<Time>;
  message?: Maybe<Message>;
  messageId: Scalars['String']['output'];
  operationType: Scalars['String']['output'];
  overrideFiles?: Maybe<Array<Scalars['String']['output']>>;
  patient?: Maybe<Patient>;
  patientId: Scalars['String']['output'];
  type: VitalType;
  updatedAt: Time;
  visit?: Maybe<Visit>;
  visitId: Scalars['String']['output'];
};

export type OperationMaterial = {
  __typename?: 'OperationMaterial';
  date: Scalars['String']['output'];
  name: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  series: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type Ordering =
  | 'ASC'
  | 'DESC';

export type OrganizationEntity = {
  __typename?: 'OrganizationEntity';
  active: Scalars['Boolean']['output'];
  displayName: Scalars['String']['output'];
  enableNoShowMitigationChance: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  p1Data?: Maybe<P1Data>;
  placeData?: Maybe<PlaceData>;
  polmedId?: Maybe<Scalars['String']['output']>;
  polmedOrganization: Scalars['Boolean']['output'];
  umxData?: Maybe<Scalars['JSON']['output']>;
};

export type OrganizationIdVojevodship =
  | 'PATIENT'
  | 'PB'
  | 'PC'
  | 'PD'
  | 'PE'
  | 'PF'
  | 'PG'
  | 'PK'
  | 'PL'
  | 'PM'
  | 'PN'
  | 'PO'
  | 'PP'
  | 'PR'
  | 'PS'
  | 'PT'
  | 'PZ';

export type Other = BaseVital & Global & {
  __typename?: 'Other';
  createdAt: Time;
  customComment?: Maybe<Scalars['String']['output']>;
  customDate?: Maybe<Time>;
  customName?: Maybe<Scalars['String']['output']>;
  delivered?: Maybe<Time>;
  doctor?: Maybe<Doctor>;
  doctorId: Scalars['String']['output'];
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  measured?: Maybe<Time>;
  message?: Maybe<Message>;
  messageId: Scalars['String']['output'];
  overrideFiles?: Maybe<Array<Scalars['String']['output']>>;
  patient?: Maybe<Patient>;
  patientId: Scalars['String']['output'];
  type: VitalType;
  updatedAt: Time;
  visit?: Maybe<Visit>;
  visitId: Scalars['String']['output'];
};

export type P1Data = {
  __typename?: 'P1Data';
  agreementNumber: Scalars['String']['output'];
  agreementNumberFull: Scalars['String']['output'];
  chamberId: Scalars['String']['output'];
  city: Scalars['String']['output'];
  flatNumber: Scalars['String']['output'];
  houseNumber: Scalars['String']['output'];
  ksr: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nfz: Scalars['String']['output'];
  nip: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  private: Scalars['Boolean']['output'];
  regon: Scalars['String']['output'];
  res5: Scalars['String']['output'];
  res7: Scalars['String']['output'];
  res8: Scalars['String']['output'];
  res8Name: Scalars['String']['output'];
  street: Scalars['String']['output'];
  unitCode: Scalars['String']['output'];
  unitName: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type P1IpomRecord = {
  __typename?: 'P1IpomRecord';
  author: Scalars['String']['output'];
  ipomCode: Scalars['String']['output'];
  issueDate: Scalars['String']['output'];
  organization: Scalars['String']['output'];
  p1Status: Scalars['String']['output'];
};

export type P1Prescription = {
  __typename?: 'P1Prescription';
  drugAmount?: Maybe<Scalars['String']['output']>;
  drugName?: Maybe<Scalars['String']['output']>;
  issueDate?: Maybe<Scalars['DateTime']['output']>;
  packageId?: Maybe<Scalars['String']['output']>;
  packageSize?: Maybe<Scalars['String']['output']>;
  prescriptionIssueStatus?: Maybe<Scalars['String']['output']>;
  prescriptionKey?: Maybe<Scalars['String']['output']>;
  prescriptionRepaymentLevel?: Maybe<Scalars['String']['output']>;
  prescriptionStatus: PrescriptionStatus;
  realizationDateFrom?: Maybe<Scalars['DateTime']['output']>;
  typeOfDrug?: Maybe<Scalars['String']['output']>;
};

export type P1PrescriptionsReturn = {
  __typename?: 'P1PrescriptionsReturn';
  lastChecked?: Maybe<Scalars['String']['output']>;
  prescriptions: Array<P1Prescription>;
};

export type PShiftVisitType =
  | 'COLLECTION'
  | 'DIETETICS'
  | 'DOCTOR_HOUSE_CALL'
  | 'DOCTOR_TELEMEDICAL_INFECTION'
  | 'EXPRESS_APPOINTMENT'
  | 'HEALTHY_CHILDREN_CHECKUP'
  | 'HEALTHY_CHILDREN_CHECKUP_AND_VACCINE'
  | 'HEALTHY_CHILDREN_PATRONAGE'
  | 'HEALTHY_CHILDREN_VACCINE'
  | 'IN_PERSON'
  | 'MIDWIFE_HOUSE_CALL'
  | 'MIDWIFE_IN_PERSON'
  | 'NURSE_HEALTHY_CHILDREN'
  | 'NURSE_HOUSE_CALL'
  | 'NURSE_IN_PERSON'
  | 'NURSE_IN_PERSON_INFECTION'
  | 'PRESCRIPTION_APPOINTMENT'
  | 'PROCEDURE'
  | 'RADIOLOGY_APPOINTMENT'
  | 'SICK_CHILDREN'
  | 'SPECIALIST'
  | 'TELEMEDICAL';

export type Package = {
  __typename?: 'Package';
  box: Scalars['String']['output'];
  continuation: Scalars['Boolean']['output'];
  dosage: Scalars['String']['output'];
  drugStatus?: Maybe<Scalars['String']['output']>;
  ean: Scalars['String']['output'];
  form: Scalars['String']['output'];
  name: Scalars['String']['output'];
  selfAdministration: Scalars['Boolean']['output'];
};

export type PacketInput = {
  icd9: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type PacketIpom = {
  __typename?: 'PacketIpom';
  icd9: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PaginatedVisitResponse = {
  __typename?: 'PaginatedVisitResponse';
  currentPage: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
  visits: Array<Visit>;
};

export type PaginatedVisitResult = {
  __typename?: 'PaginatedVisitResult';
  hasMore: Scalars['Boolean']['output'];
  items: Array<Visit>;
  total: Scalars['Float']['output'];
};

export type PaginationConfigInput = {
  skip: Scalars['Float']['input'];
  take: Scalars['Float']['input'];
};

export type PathwayInfo = {
  __typename?: 'PathwayInfo';
  id: Scalars['String']['output'];
  subtypeId?: Maybe<Scalars['String']['output']>;
};

export type PathwayRun = {
  __typename?: 'PathwayRun';
  pathways: Array<PathwayInfo>;
  runDate: Scalars['DateTime']['output'];
  runGroupId: Scalars['String']['output'];
};

export type Patient = BaseUser & Global & {
  __typename?: 'Patient';
  actionRequired?: Maybe<Scalars['String']['output']>;
  address?: Maybe<FullAddress>;
  analyticsData: AnalyticsData;
  analyticsId: Scalars['String']['output'];
  assistantId?: Maybe<Scalars['String']['output']>;
  avatar: Scalars['String']['output'];
  canBeDeleted?: Maybe<Scalars['Boolean']['output']>;
  chosenDoctor?: Maybe<Scalars['String']['output']>;
  chosenNurse?: Maybe<Scalars['String']['output']>;
  citizenship?: Maybe<Scalars['String']['output']>;
  clientAppSettings?: Maybe<ClientAppSettings>;
  consultantInfo: Scalars['JSON']['output'];
  createdAt: Time;
  currentVirtualVisit?: Maybe<Visit>;
  deliveryAddress?: Maybe<Address>;
  deviceInfo: Scalars['String']['output'];
  documents: Array<MedicalRecordEntity>;
  ekgResults: Array<EkgResults>;
  email?: Maybe<Scalars['String']['output']>;
  ewusCheckHistory: Array<EwusCheck>;
  files: Scalars['JSON']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  genre: UserGenre;
  getUnderCarePersons: Array<UnderCarePerson>;
  guardians: Array<Patient>;
  hasPassword: Scalars['Boolean']['output'];
  height?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  immunizationCardComment?: Maybe<Scalars['String']['output']>;
  immunizationCardStatus: Scalars['String']['output'];
  immunizationStatus: Scalars['Int']['output'];
  ipomCode?: Maybe<Scalars['String']['output']>;
  isPublic: Scalars['Boolean']['output'];
  isQualifiedToCHUK: Scalars['Boolean']['output'];
  izolacja?: Maybe<Scalars['String']['output']>;
  kwarantanna?: Maybe<Scalars['String']['output']>;
  lastChatMessage?: Maybe<ChatMessageEntity>;
  lastLogin: Time;
  lastName?: Maybe<Scalars['String']['output']>;
  lastPatientMessageBlock?: Maybe<Time>;
  llmAgreement?: Maybe<Scalars['Boolean']['output']>;
  locale: Scalars['String']['output'];
  medicalDataAnalysisAgreement?: Maybe<Scalars['Boolean']['output']>;
  medicalLeaves: Array<MedicalLeaveDetails>;
  messages: Array<Message>;
  mobileAppVersion: Scalars['String']['output'];
  nfzData: Scalars['JSON']['output'];
  nfzStatus: ObjectedNFZStatus;
  notificationAgreements: Array<UsersNotificationAgreementsEntity>;
  oneTimeSurvey?: Maybe<Scalars['JSON']['output']>;
  oneTimeSurveyUpdatedAt?: Maybe<Time>;
  passportCountry?: Maybe<Scalars['String']['output']>;
  passportNumber?: Maybe<Scalars['String']['output']>;
  passwordHash: Scalars['String']['output'];
  pastVisits: PaginatedVisitResult;
  patientCardNumber: Scalars['String']['output'];
  patientPublicSince?: Maybe<Time>;
  payers: Array<Payer>;
  permission: Scalars['String']['output'];
  pesel?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  phoneMarketingAgreement?: Maybe<Scalars['Boolean']['output']>;
  realNFZStatus: RealNFZStatusType;
  referralCode?: Maybe<Scalars['String']['output']>;
  referralUsagesCount: Scalars['Int']['output'];
  registrationType: Scalars['JSON']['output'];
  regularSurvey: Scalars['JSON']['output'];
  relation: Scalars['String']['output'];
  remindMe: Scalars['String']['output'];
  representative: Array<Scalars['String']['output']>;
  secretData?: Maybe<SecretData>;
  signature: Scalars['String']['output'];
  smokeLevel?: Maybe<Scalars['Float']['output']>;
  statusUbezpieczenia?: Maybe<Scalars['Int']['output']>;
  stayAddresses: Array<Address>;
  survey?: Maybe<Survey>;
  surveys: Array<SurveyProposal>;
  tags: Array<PatientTag>;
  underCarePersons: Array<UnderCarePerson>;
  uniqueIntegerId: Scalars['Int']['output'];
  unread: Scalars['Float']['output'];
  upcomingVisits: PaginatedVisitResult;
  updatedAt: Time;
  updatesToDo: Array<Scalars['String']['output']>;
  usedReferralCode?: Maybe<Scalars['String']['output']>;
  usedReferralReward: Scalars['Boolean']['output'];
  visit?: Maybe<Visit>;
  visitRecordingAndAnalysisAgreement?: Maybe<Scalars['Boolean']['output']>;
  visits: Array<Visit>;
  vital?: Maybe<VitalEntity>;
  vitals: Array<Vital>;
  wards: Array<Patient>;
  weight?: Maybe<Scalars['Float']['output']>;
};


export type PatientpastVisitsArgs = {
  ecommerceVisitsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationConfigInput>;
};


export type PatientupcomingVisitsArgs = {
  ecommerceVisitsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationConfigInput>;
};


export type PatientvisitArgs = {
  id: Scalars['String']['input'];
};


export type PatientvisitsArgs = {
  orderByCreationDate?: InputMaybe<Ordering>;
  orderByPlannedStart?: InputMaybe<Ordering>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type PatientvitalArgs = {
  id: Scalars['String']['input'];
};


export type PatientvitalsArgs = {
  visitId?: InputMaybe<Scalars['String']['input']>;
};

export type PatientData = {
  __typename?: 'PatientData';
  address?: Maybe<Address>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  patientCardNumber?: Maybe<Scalars['String']['output']>;
  pesel?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type PatientDeclarationHistoryEvent = DeclarationSubmittedEvent | UnknownEvent;

export type PatientDiedEvent = NfzEventWithVojevodship & {
  __typename?: 'PatientDiedEvent';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  vojevodship: OrganizationIdVojevodship;
};

export type PatientInput = {
  address?: InputMaybe<StayAddressInput>;
  citizenship?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  immunizationCardComment?: InputMaybe<Scalars['String']['input']>;
  immunizationCardStatus?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  passportNumber?: InputMaybe<Scalars['String']['input']>;
  payers?: InputMaybe<PayerInput>;
  pesel?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  secretData?: InputMaybe<SecretDataInput>;
  stayAddresses?: InputMaybe<StayAddressInput>;
};

export type PatientInsuranceInfo = {
  __typename?: 'PatientInsuranceInfo';
  current?: Maybe<PatientInsuranceStatusEvent>;
  latestPositive?: Maybe<PatientInsuranceStatusEvent>;
};

export type PatientInsuranceStatementData = {
  reason: InsuranceStatementPatientReason;
};

export type PatientInsuranceStatementEvent = NfzEventBase & {
  __typename?: 'PatientInsuranceStatementEvent';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  representativePatient?: Maybe<Patient>;
};

export type PatientInsuranceStatusEvent = InsuranceStatusEvent | UnknownEvent;

export type PatientIpom = {
  __typename?: 'PatientIpom';
  additionalInformation?: Maybe<Scalars['String']['output']>;
  controlVisits?: Maybe<Array<ControlVisitIpom>>;
  date: Scalars['DateTime']['output'];
  diet?: Maybe<Array<DietIpom>>;
  ipomCode: Scalars['String']['output'];
  levelStratification: LevelStratification;
  medicines?: Maybe<Array<MedicineIpom>>;
  nurse?: Maybe<Array<NurseIpom>>;
  observations?: Maybe<Array<ObservationIpom>>;
  otherAdvice?: Maybe<Scalars['String']['output']>;
  p1Response?: Maybe<Scalars['String']['output']>;
  patientId: Scalars['String']['output'];
  scheduledDiagnosticTests?: Maybe<Array<ScheduledDiagnosticTestIpom>>;
  specialistConsultations?: Maybe<Array<JmIpomVisitType>>;
  specialistVisits?: Maybe<Array<JmIpomVisitType>>;
  summary: Scalars['String']['output'];
};

export type PatientTag = {
  __typename?: 'PatientTag';
  confirmationType?: Maybe<ConfirmationType>;
  createdAt: Time;
  createdBy?: Maybe<Doctor>;
  data: Scalars['JSON']['output'];
  expirationAt?: Maybe<Scalars['DateTime']['output']>;
  history?: Maybe<Array<History>>;
  id: Scalars['String']['output'];
  patientId: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Time;
};

export type PatientTagEntity = {
  __typename?: 'PatientTagEntity';
  confirmationType?: Maybe<ConfirmationType>;
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<Doctor>;
  data: Scalars['JSON']['output'];
  expirationAt?: Maybe<Scalars['DateTime']['output']>;
  history?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['String']['output'];
  patientId: Scalars['String']['output'];
  type: PatientTagType;
  updatedAt: Scalars['DateTime']['output'];
};

export type PatientTagInput = {
  confirmationType?: InputMaybe<ConfirmationType>;
  data: Scalars['JSON']['input'];
  expirationAt?: InputMaybe<Scalars['DateTime']['input']>;
  patientId: Scalars['String']['input'];
  type: PatientTagType;
};

export type PatientTagType =
  | 'ADDITIONAL'
  | 'ALLERGY'
  | 'CHRONIC_DISEASE'
  | 'EDM_VACCINE'
  | 'HOSPITALIZATION'
  | 'REGULAR_DRUG'
  | 'SPEC_CONSULTATIONS'
  | 'SURGICAL_PROCEDURES'
  | 'VACCINES';

export type PatronageVisitInput = {
  summary?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type Payer = {
  __typename?: 'Payer';
  doNotSendPayerInfo?: Maybe<Scalars['Boolean']['output']>;
  firstName: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nip: Scalars['String']['output'];
  passportNumber: Scalars['String']['output'];
  pesel: Scalars['String']['output'];
  pueProfile: Scalars['String']['output'];
};

export type PayerInput = {
  doNotSendPayerInfo?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nip: Scalars['String']['input'];
  passportNumber?: InputMaybe<Scalars['String']['input']>;
  pesel?: InputMaybe<Scalars['String']['input']>;
  pueProfile?: InputMaybe<Scalars['String']['input']>;
};

export type PayerInputNew = {
  doNotSendPayerInfo?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nip: Scalars['String']['input'];
  passportNumber?: InputMaybe<Scalars['String']['input']>;
  pesel?: InputMaybe<Scalars['String']['input']>;
  pueProfile?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaymentDetails = {
  __typename?: 'PaymentDetails';
  description: Scalars['String']['output'];
  detailedDescription: Scalars['String']['output'];
  paymentKey: Scalars['String']['output'];
  price: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type PaymentLogEntity = {
  __typename?: 'PaymentLogEntity';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  creator: Doctor;
  id: Scalars['String']['output'];
  info: PaymentLogEntry;
  updatedAt: Scalars['DateTime']['output'];
};

export type PaymentLogEntry = {
  __typename?: 'PaymentLogEntry';
  anotherPaymentMethod?: Maybe<AnotherPaymentMethodInfo>;
  bankTransferPayment?: Maybe<BankTransferPaymentInfo>;
  customerComplaint?: Maybe<CustomerComplaintPaymentInfo>;
  employeeBenefit?: Maybe<EmployeeBenefitPaymentMethodInfo>;
  posPayment?: Maybe<PosPaymentInfo>;
};

export type PaymentLogEntryInput = {
  anotherPaymentMethod?: InputMaybe<AnotherPaymentMethodInfoInput>;
  bankTransferPayment?: InputMaybe<BankTransferPaymentInfoInput>;
  customerComplaint?: InputMaybe<CustomerComplaintPaymentInfoInput>;
  employeeBenefit?: InputMaybe<EmployeeBenefitPaymentMethodInfoInput>;
  posPayment?: InputMaybe<PosPaymentInfoInput>;
};

export type PersonMinimalDataInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type PlaceData = {
  __typename?: 'PlaceData';
  city: Scalars['String']['output'];
  houseNumber: Scalars['String']['output'];
  isPartnerFacility?: Maybe<Scalars['Boolean']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longtitude?: Maybe<Scalars['Float']['output']>;
  openingHoursCollections: Array<OpeningHours>;
  openingHoursProcedures: Array<OpeningHours>;
  openingHoursWhole: Array<OpeningHours>;
  /** If not present -> it's our own place */
  partnerName?: Maybe<Scalars['String']['output']>;
  photos: Array<Scalars['String']['output']>;
  saleorSpecialistFacilityCollectionId?: Maybe<Scalars['String']['output']>;
  street: Scalars['String']['output'];
};

export type PlacematicAddress = {
  __typename?: 'PlacematicAddress';
  city: Scalars['String']['output'];
  houseNumber?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  municipality?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  teryt?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type PlacematicAddressInput = {
  city: Scalars['String']['input'];
  houseNumber: Scalars['String']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  municipality: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  teryt: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type Placement =
  | 'NOT_APPLICABLE'
  | 'OFF_SITE'
  | 'ON_SITE';

export type PosPaymentInfo = {
  __typename?: 'PosPaymentInfo';
  paymentNumber: Scalars['String']['output'];
};

export type PosPaymentInfoInput = {
  paymentNumber: Scalars['String']['input'];
};

export type Position = {
  __typename?: 'Position';
  cancelled?: Maybe<Scalars['Boolean']['output']>;
  isNFZ?: Maybe<Scalars['Boolean']['output']>;
  positionData?: Maybe<DynamicPositionData>;
  price?: Maybe<Scalars['Float']['output']>;
  priceData?: Maybe<PriceData>;
  sampleId?: Maybe<Scalars['String']['output']>;
  serviceId?: Maybe<Scalars['String']['output']>;
  serviceName?: Maybe<Scalars['String']['output']>;
};

export type PositionInput = {
  isNFZ: Scalars['Boolean']['input'];
  serviceId: Scalars['String']['input'];
};

export type PregnacyDetails = {
  __typename?: 'PregnacyDetails';
  entirePregnacy: KeyValue;
  firstTrimester: KeyValue;
  lactation: KeyValue;
  secondTrimester: KeyValue;
  thirdTrimester: KeyValue;
};

export type Prescription = BaseMessage & Global & {
  __typename?: 'Prescription';
  code: Scalars['String']['output'];
  createdAt: Time;
  doctor: Doctor;
  doctorId: Scalars['String']['output'];
  drugs: Array<Drug>;
  endsToWork?: Maybe<Time>;
  id: Scalars['String']['output'];
  insuredIn: Scalars['String']['output'];
  isCustom: Scalars['Boolean']['output'];
  number: Scalars['String']['output'];
  options?: Maybe<PrescriptionOptions>;
  patient: Patient;
  patientId: Scalars['String']['output'];
  prescriptionId?: Maybe<Scalars['String']['output']>;
  resourceCancelationInCezDate?: Maybe<Scalars['DateTime']['output']>;
  resourceIsCompatibleWithCez?: Maybe<Scalars['Boolean']['output']>;
  startsToWork?: Maybe<Time>;
  stripeSessionId: Scalars['String']['output'];
  type: MessageType;
  updatedAt: Time;
  visit: Visit;
  visitId: Scalars['String']['output'];
  writeup: Time;
};

export type PrescriptionCEZ = {
  __typename?: 'PrescriptionCEZ';
  dataWystawieniaRecepty?: Maybe<Scalars['String']['output']>;
  miejsce: Scalars['String']['output'];
  ourDoctor: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  szczegoly: Array<Scalars['String']['output']>;
  ubezpieczenie: Array<Scalars['String']['output']>;
  wystawil: Scalars['String']['output'];
};

export type PrescriptionCezStag = {
  __typename?: 'PrescriptionCezStag';
  boxAmount: Scalars['Float']['output'];
  cost: Scalars['String']['output'];
  dose: Scalars['String']['output'];
  drug: Scalars['String']['output'];
  form: Scalars['String']['output'];
  interval: Scalars['String']['output'];
  package: Scalars['String']['output'];
  status: PrescriptionStatus;
};

export type PrescriptionChatMessageDeletedEvent = {
  __typename?: 'PrescriptionChatMessageDeletedEvent';
  message: ChatMessageEntity;
};

export type PrescriptionInput = {
  assignmentType: Scalars['String']['input'];
  data: Scalars['JSON']['input'];
  positions: Array<PositionInput>;
  visitId: Scalars['String']['input'];
};

export type PrescriptionOptions = {
  __typename?: 'PrescriptionOptions';
  cito?: Maybe<Scalars['Boolean']['output']>;
  dontChange?: Maybe<Scalars['Boolean']['output']>;
  in365days?: Maybe<Scalars['Boolean']['output']>;
};

export type PrescriptionRequestDto = {
  __typename?: 'PrescriptionRequestDto';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  pending: Scalars['Boolean']['output'];
  prescriptions: Array<Prescription>;
  recommendations?: Maybe<Scalars['String']['output']>;
  requestedDrugs: Array<RequestedDrugDto>;
  solvedOn?: Maybe<Scalars['DateTime']['output']>;
};

export type PrescriptionResult = {
  __typename?: 'PrescriptionResult';
  messageId: Scalars['String']['output'];
  prescriptionCode: Scalars['String']['output'];
};

export type PrescriptionStatus =
  | 'CANCELED'
  | 'COMPLETED'
  | 'ISSUED'
  | 'PARTIALLY_COMPLETED';

export type PrescriptionsPacketCezStag = {
  __typename?: 'PrescriptionsPacketCezStag';
  insurance: Array<Scalars['String']['output']>;
  issueDate?: Maybe<Scalars['String']['output']>;
  issuedBy: Scalars['String']['output'];
  ourDoctor: Scalars['Boolean']['output'];
  place: Scalars['String']['output'];
  prescriptions: Array<PrescriptionCezStag>;
  status: PrescriptionStatus;
};

export type PrescriptionsReturn = {
  __typename?: 'PrescriptionsReturn';
  lastChecked?: Maybe<Scalars['String']['output']>;
  prescriptions: Array<PrescriptionCEZ>;
};

export type PrescriptionsReturnStag = {
  __typename?: 'PrescriptionsReturnStag';
  lastChecked?: Maybe<Scalars['String']['output']>;
  prescriptionsPacket: PrescriptionsPacketCezStag;
};

export type Pressure = BaseVital & Global & {
  __typename?: 'Pressure';
  createdAt: Time;
  customDate?: Maybe<Time>;
  delivered?: Maybe<Time>;
  diastolic: Scalars['Int']['output'];
  doctor?: Maybe<Doctor>;
  doctorId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  measured?: Maybe<Time>;
  message?: Maybe<Message>;
  messageId: Scalars['String']['output'];
  overrideFiles?: Maybe<Array<Scalars['String']['output']>>;
  patient?: Maybe<Patient>;
  patientId: Scalars['String']['output'];
  systolic: Scalars['Int']['output'];
  type: VitalType;
  updatedAt: Time;
  visit?: Maybe<Visit>;
  visitId: Scalars['String']['output'];
};

export type PriceData = {
  __typename?: 'PriceData';
  NFZ?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  original?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** Świadczenia główne */
export type PrimaryMedicalService =
  /** Porada kompleksowa w opiece koordynowanej */
  | 'COMPLEX'
  /** Porada kontrolna w opiece koordynowanej */
  | 'CONTROL'
  /** Bilans zdrowia w wieku 20-59 */
  | 'HEALTH_CHECK_20_59'
  /** Bilans zdrowia w wieku 60+ */
  | 'HEALTH_CHECK_60_PLUS'
  /** Porada edukacyjna - Bilans zdrowia */
  | 'HEALTH_EDUCATION'
  /** Wizyta wstępna w opiece koordynowanej */
  | 'INITIAL'
  /** Porada pacjent-specjalista w dziedzinie alergologii */
  | 'IPOM_ALLERGOLOGY'
  /** Porada pacjent-specjalista w dziedzinie kardiologii */
  | 'IPOM_CARDIOLOGY'
  /** Porada pacjent-specjalista w dziedzinie diabetologii */
  | 'IPOM_DIABETOLOGY'
  /** Konsultacja dietetyczna w Opiece Koordynowanej */
  | 'IPOM_DIET'
  /** Porada edukacyjna - Opieka Koordynowana */
  | 'IPOM_EDUCATION'
  /** Porada pacjent-specjalista w dziedzinie endokrynologii */
  | 'IPOM_ENDOCRINOLOGY'
  /** Porada pacjent-specjalista w dziedzinie nefrologii */
  | 'IPOM_NEPHROLOGY'
  /** Porada pacjent-specjalista w dziedzinie pulmonologii */
  | 'IPOM_PULMONOLOGY'
  /** Brak */
  | 'NONE';

export type ProcedureAnswer = {
  __typename?: 'ProcedureAnswer';
  answer?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Scalars['String']['output']>;
};

export type ProcedureAnswerInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export type ProcedureBandage = {
  __typename?: 'ProcedureBandage';
  expirationDate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productSeries?: Maybe<Scalars['String']['output']>;
  used?: Maybe<Scalars['String']['output']>;
};

export type ProcedureBandageInput = {
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productSeries?: InputMaybe<Scalars['String']['input']>;
  used?: InputMaybe<Scalars['String']['input']>;
};

export type ProcedureChukEducation = {
  __typename?: 'ProcedureChukEducation';
  cholesterol?: Maybe<Scalars['Float']['output']>;
  cholesterolHDL?: Maybe<Scalars['Float']['output']>;
  cholesterolLDL?: Maybe<Scalars['Float']['output']>;
  cholesterolNonHDL?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  glucose?: Maybe<Scalars['Float']['output']>;
  recommendations?: Maybe<Scalars['String']['output']>;
  riskScore?: Maybe<Scalars['Float']['output']>;
  simpFiles?: Maybe<Array<Scalars['String']['output']>>;
  triglycerides?: Maybe<Scalars['Float']['output']>;
};

export type ProcedureChukMeasurements = {
  __typename?: 'ProcedureChukMeasurements';
  bodyMeasurements?: Maybe<ChukBodyMeasurements>;
  comment?: Maybe<Scalars['String']['output']>;
  pressureMeasurements?: Maybe<Array<ChukPressureMeasurement>>;
};

export type ProcedureDataInput = {
  answers?: InputMaybe<Array<ProcedureAnswerInput>>;
  bandage?: InputMaybe<Array<ProcedureBandageInput>>;
  chukEducation?: InputMaybe<ChukEducationInput>;
  chukMeasurements?: InputMaybe<ChukMeasurementsInput>;
  disinfectant?: InputMaybe<Array<ProcedureDisinfectantInput>>;
  doctorAdvice?: InputMaybe<DoctorAdviceInput>;
  doctorDiagnosis?: InputMaybe<Array<DiagnosisInput>>;
  dressingChange?: InputMaybe<ProcedureDressingChangeInput>;
  drug?: InputMaybe<Array<ProcedureDrugInput>>;
  education?: InputMaybe<ProcedureEducationInput>;
  ekg?: InputMaybe<ProcedureEKGInput>;
  file?: InputMaybe<Array<Scalars['String']['input']>>;
  foreignBody?: InputMaybe<ProcedureForeignBodyInput>;
  isEditingLocked?: InputMaybe<Scalars['Boolean']['input']>;
  measurement?: InputMaybe<Array<MeasurementInput>>;
  medicalAct?: InputMaybe<MedicalActInput>;
  medication?: InputMaybe<ProcedureMedicationInput>;
  midwifeEducationalVisit?: InputMaybe<MidwifeEducationalVisit>;
  nurseAdvice?: InputMaybe<NurseAdviceInput>;
  observations?: InputMaybe<Scalars['String']['input']>;
  patronageVisit?: InputMaybe<PatronageVisitInput>;
  recommendation?: InputMaybe<Scalars['String']['input']>;
  spirometry?: InputMaybe<ProcedureSpirometryInput>;
  stitch?: InputMaybe<ProcedureStitchInput>;
  tool?: InputMaybe<Array<ProcedureToolInput>>;
  tuberculosisEducation?: InputMaybe<TuberculosisEducationInput>;
  usg?: InputMaybe<UsgInput>;
  vaccine?: InputMaybe<Array<VaccineInput>>;
  vaccineData?: InputMaybe<ProcedureVaccineBasicDataInput>;
};

export type ProcedureDisinfectant = {
  __typename?: 'ProcedureDisinfectant';
  expirationDate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productSeries?: Maybe<Scalars['String']['output']>;
  used?: Maybe<Scalars['String']['output']>;
};

export type ProcedureDisinfectantInput = {
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productSeries?: InputMaybe<Scalars['String']['input']>;
  used?: InputMaybe<Scalars['String']['input']>;
};

export type ProcedureDressingChange = {
  __typename?: 'ProcedureDressingChange';
  place?: Maybe<Scalars['String']['output']>;
  secretion?: Maybe<SecretionType>;
  type?: Maybe<Scalars['String']['output']>;
  woundClassification?: Maybe<Array<Scalars['String']['output']>>;
  woundHealingStatus?: Maybe<WoundHealingStatus>;
};

export type ProcedureDressingChangeInput = {
  place?: InputMaybe<Scalars['String']['input']>;
  secretion?: InputMaybe<SecretionType>;
  type?: InputMaybe<Scalars['String']['input']>;
  woundClassification?: InputMaybe<Array<Scalars['String']['input']>>;
  woundHealingStatus?: InputMaybe<WoundHealingStatus>;
};

export type ProcedureDrug = {
  __typename?: 'ProcedureDrug';
  expirationDate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productSeries?: Maybe<Scalars['String']['output']>;
  used?: Maybe<Scalars['String']['output']>;
};

export type ProcedureDrugInput = {
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productSeries?: InputMaybe<Scalars['String']['input']>;
  used?: InputMaybe<Scalars['String']['input']>;
};

export type ProcedureEKG = {
  __typename?: 'ProcedureEKG';
  cito?: Maybe<Scalars['Boolean']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
};

export type ProcedureEKGInput = {
  cito?: InputMaybe<Scalars['Boolean']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
};

export type ProcedureEducation = {
  __typename?: 'ProcedureEducation';
  comment?: Maybe<Scalars['String']['output']>;
};

export type ProcedureEducationInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  ipomEducation?: InputMaybe<Scalars['Boolean']['input']>;
  myHealthEducation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProcedureEntity = {
  __typename?: 'ProcedureEntity';
  answers: Array<ProcedureAnswer>;
  bandages: Array<ProcedureBandage>;
  cancelled: Scalars['Boolean']['output'];
  chukEducation?: Maybe<ProcedureChukEducation>;
  chukMeasurements?: Maybe<ProcedureChukMeasurements>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdOnVisitId?: Maybe<Scalars['String']['output']>;
  creator: User;
  data?: Maybe<Scalars['JSON']['output']>;
  disinfectants: Array<ProcedureDisinfectant>;
  displayName: Scalars['String']['output'];
  doctorDiagnosis?: Maybe<Array<Maybe<Diagnosis>>>;
  dressingChange?: Maybe<ProcedureDressingChange>;
  drugs: Array<ProcedureDrug>;
  education?: Maybe<ProcedureEducation>;
  ekg?: Maybe<ProcedureEKG>;
  executionLimit: Scalars['String']['output'];
  files?: Maybe<Array<Scalars['String']['output']>>;
  foreignBody?: Maybe<ProcedureForeignBody>;
  id: Scalars['String']['output'];
  isEditingLocked: Scalars['Boolean']['output'];
  measurements: Array<ProcedureMeasurement>;
  medicalAct?: Maybe<ProcedureMedicalAct>;
  medication?: Maybe<ProcedureMedication>;
  messageId?: Maybe<Scalars['String']['output']>;
  midwifeEducationalVisit?: Maybe<ProcedureMidwifeEducationalVisit>;
  observations: Scalars['String']['output'];
  paid: Scalars['Boolean']['output'];
  patient: Patient;
  patientId: Scalars['String']['output'];
  patronageVisit?: Maybe<ProcedureParonageVisit>;
  spirometry?: Maybe<ProcedureSpirometry>;
  stitch?: Maybe<ProcedureStitch>;
  tools: Array<ProcedureTool>;
  tuberculosisEducation?: Maybe<ProcedureTuberculosisEducation>;
  type: ProcedureType;
  updatedAt: Scalars['DateTime']['output'];
  usg?: Maybe<ProcedureUsg>;
  vaccineData?: Maybe<ProcedureVaccineBasicData>;
  vaccines: Array<ProcedureVaccine>;
  visit?: Maybe<Visit>;
  visitId?: Maybe<Scalars['String']['output']>;
};

export type ProcedureForeignBody = {
  __typename?: 'ProcedureForeignBody';
  comment?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ProcedureForeignBodyInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ProcedureMeasurement = {
  __typename?: 'ProcedureMeasurement';
  diastolicPressure?: Maybe<Scalars['String']['output']>;
  pulse?: Maybe<Scalars['String']['output']>;
  resultType?: Maybe<Scalars['String']['output']>;
  systolicPressure?: Maybe<Scalars['String']['output']>;
};

export type ProcedureMedicalAct = {
  __typename?: 'ProcedureMedicalAct';
  comment?: Maybe<Scalars['String']['output']>;
  diastolicPressure?: Maybe<Scalars['String']['output']>;
  glycemia?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['String']['output']>;
  pulse?: Maybe<Scalars['String']['output']>;
  systolicPressure?: Maybe<Scalars['String']['output']>;
  temperature?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['String']['output']>;
};

export type ProcedureMedication = {
  __typename?: 'ProcedureMedication';
  cito?: Maybe<Scalars['Boolean']['output']>;
  dosing?: Maybe<Scalars['String']['output']>;
  injection?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ProcedureMedicationInput = {
  cito?: InputMaybe<Scalars['Boolean']['input']>;
  dosing?: InputMaybe<Scalars['String']['input']>;
  injection?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ProcedureMidwifeEducationalVisit = {
  __typename?: 'ProcedureMidwifeEducationalVisit';
  pregnacyWeek?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  visitTopics?: Maybe<Array<Scalars['String']['output']>>;
};

export type ProcedureParonageVisit = {
  __typename?: 'ProcedureParonageVisit';
  summary?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ProcedureSchema = {
  __typename?: 'ProcedureSchema';
  create: Scalars['JSON']['output'];
  edit: Scalars['JSON']['output'];
};

export type ProcedureSpirometry = {
  __typename?: 'ProcedureSpirometry';
  comments?: Maybe<Scalars['String']['output']>;
  diastolicTest?: Maybe<Scalars['Boolean']['output']>;
  examinationComments?: Maybe<Scalars['String']['output']>;
};

export type ProcedureSpirometryInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  diastolicTest?: InputMaybe<Scalars['Boolean']['input']>;
  examinationComments?: InputMaybe<Scalars['String']['input']>;
};

export type ProcedureStitch = {
  __typename?: 'ProcedureStitch';
  place?: Maybe<Scalars['String']['output']>;
  woundHealingStatus?: Maybe<WoundHealingStatus>;
};

export type ProcedureStitchInput = {
  place?: InputMaybe<Scalars['String']['input']>;
  woundHealingStatus?: InputMaybe<WoundHealingStatus>;
};

export type ProcedureTool = {
  __typename?: 'ProcedureTool';
  expirationDate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productSeries?: Maybe<Scalars['String']['output']>;
  used?: Maybe<Scalars['String']['output']>;
};

export type ProcedureToolInput = {
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productSeries?: InputMaybe<Scalars['String']['input']>;
  used?: InputMaybe<Scalars['String']['input']>;
};

export type ProcedureTuberculosisEducation = {
  __typename?: 'ProcedureTuberculosisEducation';
  patientEducated?: Maybe<Scalars['Boolean']['output']>;
  riskGroup?: Maybe<TuberculosisRiskLevel>;
  score?: Maybe<Scalars['Float']['output']>;
  telemedicalConsultation?: Maybe<Scalars['Boolean']['output']>;
};

export type ProcedureType =
  | 'BANDAGE'
  | 'CHUK_EDUCATION'
  | 'CHUK_MEASUREMENTS'
  | 'DOCTOR_ADVICE'
  | 'DRUGPASS'
  | 'EDUCATION'
  | 'EKG'
  | 'MEDICAL_ACT'
  | 'MIDWIFE_EDUCATIONAL_VISIT'
  | 'NURSE_ADVICE'
  | 'OBJECT'
  | 'PATRONAGE_VISIT'
  | 'QUALIFICATION_FOR_VACCINATION'
  | 'SPIRO'
  | 'SPIROMETRY'
  | 'STITCHES'
  | 'TUBERCULOSIS_EDUCATION'
  | 'USG'
  | 'VACCINE';

export type ProcedureUsg = {
  __typename?: 'ProcedureUsg';
  attachments?: Maybe<Array<Scalars['String']['output']>>;
  comment?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  referral?: Maybe<ProcedureUsgReferralInfo>;
  referralId?: Maybe<Scalars['String']['output']>;
  service?: Maybe<AssignmentEntity>;
  serviceId?: Maybe<Scalars['String']['output']>;
};

export type ProcedureUsgReferralInfo = {
  __typename?: 'ProcedureUsgReferralInfo';
  comment: Scalars['String']['output'];
  mainDiagnosis: Scalars['String']['output'];
  procedureName: Scalars['String']['output'];
};

export type ProcedureVaccine = {
  __typename?: 'ProcedureVaccine';
  dose?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productSeries?: Maybe<Scalars['String']['output']>;
};

export type ProcedureVaccineBasicData = {
  __typename?: 'ProcedureVaccineBasicData';
  comment?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ProcedureVaccineBasicDataInput = {
  comment: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  ICD9: Array<Scalars['String']['output']>;
  ICD10: Array<Scalars['String']['output']>;
  additionalMedicalServices: Array<Scalars['String']['output']>;
  archivedVisitList: PaginatedVisitResponse;
  authorizeDoctor: Scalars['String']['output'];
  authorizeMFA: TokensPayload;
  calendar: Array<ImmuCalendarOutput>;
  chatMessages: Array<ChatMessageEntity>;
  checkCEZ: Scalars['String']['output'];
  checkPatientExists: Scalars['Boolean']['output'];
  clinics: Array<Clinic>;
  diag: Array<Diag>;
  doctor?: Maybe<Doctor>;
  doctorGeneratePdf: Scalars['String']['output'];
  doctors: Array<Doctor>;
  draftVisits: Array<Visit>;
  drugRecipes: Array<DrugRecipe>;
  findAddress: Array<PlacematicAddress>;
  findAddressMultistring: Array<PlacematicAddress>;
  getAdditionalRefundRightsWithExplanation: Scalars['JSON']['output'];
  getDoctorsVisits: Array<Visit>;
  getDoctorsWithAvailableSlots: Array<Doctor>;
  getDrugDetails: DrugDetails;
  getIpom?: Maybe<PatientIpom>;
  getIpomCodes: Array<Scalars['String']['output']>;
  getIpomSpecialists: Array<Scalars['String']['output']>;
  getMessagesForPatient: Array<Message>;
  getNearestNFZSlotTime?: Maybe<Scalars['String']['output']>;
  getP1Prescriptions: P1PrescriptionsReturn;
  getPatientDocs: Scalars['String']['output'];
  getPatientDocs2: Scalars['String']['output'];
  getPrescriptionsForPatient: Array<Prescription>;
  getReferralsForPatient: Array<Referral>;
  getSlots: Array<FreeTime>;
  getSlotsRecipe: Array<FreeTime>;
  getSpecialistSlots: Array<FreeTime>;
  getTemplatesForVisit: Array<LabExamTemplate>;
  getVisitsPerDayForDoctor: Array<Visit>;
  getZusMedicalLeaves: Array<ZusMedicalLeave>;
  getZusPayers: Array<ZusPayer>;
  getZusPayersByNIP: Array<ZusPayer>;
  groupByChatMessage: Array<ChatMessageEntity>;
  historyVisits: Array<Visit>;
  laboratoryExaminationDiagsWithPackets: Array<DiagOrPacket>;
  laboratoryExaminationReport: Scalars['String']['output'];
  laboratoryExaminations: Array<LaboratoryExaminationEntity>;
  leaves: Array<Leave>;
  manyProceduresRender: Array<RenderedProcedure>;
  me: DoctorWithSecrets;
  medicalServices: Array<MedicalServices>;
  medicineSubtitles: Array<MedicineSubtitle>;
  myUpcomingVisits: Array<Visit>;
  nextPatient: Scalars['String']['output'];
  nextPatients: Array<Patient>;
  nfzEvents: Array<NFZEventEntity>;
  nfzHistory: Array<NfzHistoryEvent>;
  numberOfPrescriptionRequests: Scalars['Float']['output'];
  organizations: Array<OrganizationEntity>;
  packages: Array<Package>;
  patient?: Maybe<Patient>;
  patientDeclarationHistory: Array<PatientDeclarationHistoryEvent>;
  patientInsuranceStatus: PatientInsuranceInfo;
  patients: Array<Patient>;
  popularLaboratoryExaminationPackets: Array<DiagPacket>;
  prescriptionsCEZ: PrescriptionsReturn;
  prescriptionsCEZStag: PrescriptionsReturnStag;
  procedureRender: RenderedProcedure;
  procedures: Array<ProcedureEntity>;
  regularDrugs: Array<RegularDrug>;
  reportGenerate: Scalars['String']['output'];
  reports: Array<ReportingEventEntity>;
  scheduledVisits: Array<Visit>;
  searchIPOMs?: Maybe<Array<P1IpomRecord>>;
  sendMfaSmsCode: Scalars['Boolean']['output'];
  shiftTypes: Array<Scalars['String']['output']>;
  shifts: ShiftsOutput;
  snippetTags: Array<SelectOption>;
  snippets: Array<Snippet>;
  swiadGenerate: Scalars['String']['output'];
  todayComboTest: Scalars['Boolean']['output'];
  todos: Array<TodoEntity>;
  upcomingVisits: Array<Visit>;
  validateReferralCode: Scalars['Boolean']['output'];
  validateToken: Scalars['String']['output'];
  visit: Visit;
  visitsForPatients: Array<Visit>;
  wards: Array<Scalars['String']['output']>;
};


export type QueryICD9Args = {
  search: Scalars['String']['input'];
};


export type QueryICD10Args = {
  search: Scalars['String']['input'];
};


export type QueryadditionalMedicalServicesArgs = {
  visitId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryarchivedVisitListArgs = {
  filters?: InputMaybe<VisitFilterInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryauthorizeDoctorArgs = {
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};


export type QueryauthorizeMFAArgs = {
  mfaCode: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};


export type QuerycalendarArgs = {
  id: Scalars['String']['input'];
};


export type QuerychatMessagesArgs = {
  createdAtGt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtLt?: InputMaybe<Scalars['DateTime']['input']>;
  patientId: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerycheckCEZArgs = {
  visitId: Scalars['String']['input'];
};


export type QuerycheckPatientExistsArgs = {
  pesel?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};


export type QuerydiagArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
  search: Scalars['String']['input'];
  type: AssignmentType;
};


export type QuerydoctorArgs = {
  id: Scalars['String']['input'];
};


export type QuerydoctorGeneratePdfArgs = {
  representativeId?: InputMaybe<Scalars['String']['input']>;
  request: Array<NfzDeclarationInputPatientMultiple>;
};


export type QuerydoctorsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  showBlocked?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerydraftVisitsArgs = {
  patientId: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryfindAddressArgs = {
  query: Scalars['String']['input'];
  voivodeship?: InputMaybe<Scalars['String']['input']>;
};


export type QueryfindAddressMultistringArgs = {
  city: Scalars['String']['input'];
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetPrefix?: InputMaybe<StreetPrefix>;
  voivodeship: Scalars['String']['input'];
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetDoctorsVisitsArgs = {
  doctorId: Scalars['String']['input'];
  plannedStartGte: Scalars['DateTime']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  visitType: VisitType;
};


export type QuerygetDoctorsWithAvailableSlotsArgs = {
  end?: InputMaybe<Scalars['Float']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Float']['input']>;
  type: SlotType;
};


export type QuerygetDrugDetailsArgs = {
  ean: Scalars['String']['input'];
};


export type QuerygetIpomArgs = {
  patientId: Scalars['String']['input'];
};


export type QuerygetIpomCodesArgs = {
  patientId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetIpomSpecialistsArgs = {
  patientId: Scalars['String']['input'];
};


export type QuerygetMessagesForPatientArgs = {
  patientId: Scalars['String']['input'];
};


export type QuerygetP1PrescriptionsArgs = {
  patientId?: InputMaybe<Scalars['String']['input']>;
  visitId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetPatientDocsArgs = {
  patientId: Scalars['String']['input'];
};


export type QuerygetPatientDocs2Args = {
  patientId: Scalars['String']['input'];
};


export type QuerygetPrescriptionsForPatientArgs = {
  patientId: Scalars['String']['input'];
};


export type QuerygetReferralsForPatientArgs = {
  patientId: Scalars['String']['input'];
};


export type QuerygetSlotsArgs = {
  doctorId?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['Float']['input']>;
  isChild?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  organizationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredLanguages?: InputMaybe<Array<SupportedLanguage>>;
  slotsInRow?: InputMaybe<Scalars['Float']['input']>;
  start?: InputMaybe<Scalars['Float']['input']>;
  triageData?: InputMaybe<Scalars['String']['input']>;
  type: SlotType;
};


export type QuerygetSlotsRecipeArgs = {
  end?: InputMaybe<Scalars['Float']['input']>;
  organizationIdForced?: InputMaybe<Scalars['String']['input']>;
  serviceType?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Float']['input']>;
  triageData?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetSpecialistSlotsArgs = {
  doctorId?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['Float']['input']>;
  isChild?: InputMaybe<Scalars['Boolean']['input']>;
  requiredLanguages?: InputMaybe<Array<SupportedLanguage>>;
  serviceId: Scalars['String']['input'];
  start?: InputMaybe<Scalars['Float']['input']>;
};


export type QuerygetTemplatesForVisitArgs = {
  visitId: Scalars['String']['input'];
};


export type QuerygetVisitsPerDayForDoctorArgs = {
  doctorId?: InputMaybe<Scalars['String']['input']>;
  forDay: Scalars['DateTime']['input'];
};


export type QuerygetZusMedicalLeavesArgs = {
  input: GetMedicalLeavesInput;
};


export type QuerygetZusPayersArgs = {
  input: GetZusPayersInput;
};


export type QuerygetZusPayersByNIPArgs = {
  input: GetZusPayersByNIPInput;
};


export type QuerygroupByChatMessageArgs = {
  authorId: Scalars['String']['input'];
  forDay: Scalars['DateTime']['input'];
};


export type QueryhistoryVisitsArgs = {
  patientId: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerylaboratoryExaminationDiagsWithPacketsArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
  search: Scalars['String']['input'];
};


export type QuerylaboratoryExaminationReportArgs = {
  end: Scalars['String']['input'];
  organizationCode: Scalars['String']['input'];
  start: Scalars['String']['input'];
};


export type QuerylaboratoryExaminationsArgs = {
  groupId?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  patientId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryleavesArgs = {
  patientId: Scalars['String']['input'];
};


export type QuerymanyProceduresRenderArgs = {
  procedureIds: Array<Scalars['String']['input']>;
  visitId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerymedicineSubtitlesArgs = {
  type: PatientTagType;
};


export type QuerynfzEventsArgs = {
  patientId: Scalars['String']['input'];
};


export type QuerynfzHistoryArgs = {
  patientId: Scalars['String']['input'];
};


export type QueryorganizationsArgs = {
  showPolmed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerypackagesArgs = {
  name: Scalars['String']['input'];
};


export type QuerypatientArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  patientCardNumber?: InputMaybe<Scalars['String']['input']>;
  pesel?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};


export type QuerypatientDeclarationHistoryArgs = {
  patientId: Scalars['String']['input'];
};


export type QuerypatientInsuranceStatusArgs = {
  patientId: Scalars['String']['input'];
};


export type QuerypatientsArgs = {
  fullText?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take: Scalars['Int']['input'];
};


export type QuerypopularLaboratoryExaminationPacketsArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryprescriptionsCEZArgs = {
  patientId?: InputMaybe<Scalars['String']['input']>;
  visitId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryprescriptionsCEZStagArgs = {
  patientId?: InputMaybe<Scalars['String']['input']>;
  visitId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryprocedureRenderArgs = {
  procedureId?: InputMaybe<Scalars['String']['input']>;
  type: ProcedureType;
  visitId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryproceduresArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  patientId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryregularDrugsArgs = {
  patientId: Scalars['String']['input'];
};


export type QueryreportGenerateArgs = {
  organizationId: Scalars['String']['input'];
  periodSymbol: Scalars['String']['input'];
  version: Scalars['String']['input'];
};


export type QueryreportsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  periodSymbol: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryscheduledVisitsArgs = {
  doctorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  forDay: Scalars['DateTime']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerysearchIPOMsArgs = {
  patientId: Scalars['String']['input'];
};


export type QuerysendMfaSmsCodeArgs = {
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};


export type QueryshiftTypesArgs = {
  shiftGenre?: InputMaybe<Scalars['String']['input']>;
};


export type QueryshiftsArgs = {
  from: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
  to: Scalars['String']['input'];
};


export type QuerysnippetsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryswiadGenerateArgs = {
  organizationId: Scalars['String']['input'];
  periodSymbol: Scalars['String']['input'];
  version: Scalars['String']['input'];
};


export type QuerytodayComboTestArgs = {
  patientId: Scalars['String']['input'];
};


export type QuerytodosArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryupcomingVisitsArgs = {
  patientId: Scalars['String']['input'];
};


export type QueryvalidateReferralCodeArgs = {
  referralCode: Scalars['String']['input'];
};


export type QueryvisitArgs = {
  id: Scalars['String']['input'];
};


export type QueryvisitsForPatientsArgs = {
  forDay: Scalars['DateTime']['input'];
  patientIds: Array<Scalars['String']['input']>;
};

export type RTPayload = {
  jwt: Scalars['String']['input'];
  refreshToken: Scalars['String']['input'];
};

export type Range = {
  __typename?: 'Range';
  max: Scalars['String']['output'];
  min: Scalars['String']['output'];
};

export type RealNFZStatusType =
  | 'DONOTREPORT'
  | 'NOTDECLARABLE'
  | 'O'
  | 'P'
  | 'PENDING'
  | 'TODECLARE'
  | 'Z';

export type Referral = BaseMessage & Global & {
  __typename?: 'Referral';
  adviceGoal?: Maybe<Scalars['String']['output']>;
  clinic?: Maybe<ClinicDetails>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Time;
  doctor: Doctor;
  doctorId: Scalars['String']['output'];
  examinationType?: Maybe<Scalars['String']['output']>;
  icd9?: Maybe<ICD9Main>;
  icd10?: Maybe<ICD10Main>;
  id: Scalars['String']['output'];
  patient: Patient;
  patientId: Scalars['String']['output'];
  purpose?: Maybe<Scalars['String']['output']>;
  referralDetails: ReferralDetails;
  referralType: Scalars['String']['output'];
  stripeSessionId: Scalars['String']['output'];
  type: MessageType;
  updatedAt: Time;
  urgent?: Maybe<Scalars['Boolean']['output']>;
  visit: Visit;
  visitId: Scalars['String']['output'];
  ward?: Maybe<WardDetails>;
};

export type ReferralDetails = {
  __typename?: 'ReferralDetails';
  code?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
};

export type RegistrationSource =
  | 'MOBILE'
  | 'WEB';

export type RegularDrug = {
  __typename?: 'RegularDrug';
  drugDetails?: Maybe<DrugDetails>;
  sourceTag: PatientTagEntity;
};

export type RenderedProcedure = {
  __typename?: 'RenderedProcedure';
  context: Scalars['JSON']['output'];
  create?: Maybe<Scalars['String']['output']>;
  data: Scalars['JSON']['output'];
  edit?: Maybe<Scalars['String']['output']>;
  print?: Maybe<Scalars['String']['output']>;
  schema: ProcedureSchema;
  view?: Maybe<Scalars['String']['output']>;
};

export type ReportingEventEntity = {
  __typename?: 'ReportingEventEntity';
  data?: Maybe<Scalars['JSON']['output']>;
  error?: Maybe<Scalars['JSON']['output']>;
  meta?: Maybe<Scalars['JSON']['output']>;
  organizationId: Scalars['String']['output'];
  periodSymbol: Scalars['String']['output'];
  sourceId: Scalars['String']['output'];
  type: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type RepresentativeInsuranceStatementData = {
  reason: InsuranceStatementRepresentativeReason;
  representativePatientId?: InputMaybe<Scalars['String']['input']>;
};

export type RequestedDrugDto = {
  __typename?: 'RequestedDrugDto';
  details: DrugDetails;
  ean: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  regularDrugSourceTag?: Maybe<PatientTagEntity>;
  resolvedInPrescriptions?: Maybe<Array<Prescription>>;
};

export type Rtg = BaseVital & Global & {
  __typename?: 'Rtg';
  createdAt: Time;
  customDate?: Maybe<Time>;
  delivered?: Maybe<Time>;
  doctor?: Maybe<Doctor>;
  doctorId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  measured?: Maybe<Time>;
  message?: Maybe<Message>;
  messageId: Scalars['String']['output'];
  overrideFiles?: Maybe<Array<Scalars['String']['output']>>;
  patient?: Maybe<Patient>;
  patientId: Scalars['String']['output'];
  type: VitalType;
  updatedAt: Time;
  visit?: Maybe<Visit>;
  visitId: Scalars['String']['output'];
};

export type SMSNotifications = {
  __typename?: 'SMSNotifications';
  deadline: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
};

export type ScheduledDiagnosticTestInput = {
  date?: InputMaybe<Scalars['String']['input']>;
  icd9?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  packet?: InputMaybe<Array<PacketInput>>;
  time: IpomTimeType;
  timeName?: InputMaybe<Scalars['String']['input']>;
  timeUnit?: InputMaybe<IpomTimeUnit>;
  timeValue?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type ScheduledDiagnosticTestIpom = {
  __typename?: 'ScheduledDiagnosticTestIpom';
  date?: Maybe<Scalars['String']['output']>;
  icd9?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  packet?: Maybe<Array<PacketIpom>>;
  time: IpomTimeType;
  timeName?: Maybe<Scalars['String']['output']>;
  timeUnit?: Maybe<IpomTimeUnit>;
  timeValue?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type SecretData = {
  __typename?: 'SecretData';
  breastfeeding?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hearingdisabled?: Maybe<Scalars['Boolean']['output']>;
  nice?: Maybe<Scalars['Boolean']['output']>;
  notnice?: Maybe<Scalars['Boolean']['output']>;
  physicallydisabled?: Maybe<Scalars['Boolean']['output']>;
  pregnant?: Maybe<Scalars['Boolean']['output']>;
};

export type SecretDataInput = {
  breastfeeding?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hearingdisabled?: InputMaybe<Scalars['Boolean']['input']>;
  nice?: InputMaybe<Scalars['Boolean']['input']>;
  notnice?: InputMaybe<Scalars['Boolean']['input']>;
  physicallydisabled?: InputMaybe<Scalars['Boolean']['input']>;
  pregnant?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SecretionType =
  | 'BLOODY'
  | 'PURULENT'
  | 'SEROUS';

export type SelectOption = {
  __typename?: 'SelectOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SelectOptionInput = {
  label: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type SelectedDocumentInput = {
  academicalTestimonial?: InputMaybe<AcademicalTestimonialInput>;
  becikoweTestimonial?: InputMaybe<BecikoweTestimonialInput>;
  medicalTestimonial?: InputMaybe<MedicalTestimonialInput>;
  ol9Testimonial?: InputMaybe<OL9TestimonialInput>;
  zas2Testimonial?: InputMaybe<ZAS2TestimonialInput>;
  zas38Testimonial?: InputMaybe<ZAS38TestimonialInput>;
};

export type SelfOrdinatedDrugDto = {
  __typename?: 'SelfOrdinatedDrugDto';
  details: DrugDetails;
  ean: Scalars['String']['output'];
  expirationDate: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
  visitId: Scalars['String']['output'];
};

export type SentNoShowNotifications = {
  __typename?: 'SentNoShowNotifications';
  answer?: Maybe<NoShowNotificationAnswer>;
  notifications: SentNotifications;
};

export type SentNotifications = {
  __typename?: 'SentNotifications';
  cancelled?: Maybe<Scalars['String']['output']>;
  warnings: Array<Maybe<Scalars['String']['output']>>;
};

export type ServiceStaffEntity = {
  __typename?: 'ServiceStaffEntity';
  colsynced?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  organizationId: Scalars['String']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  saleorProductId?: Maybe<Scalars['String']['output']>;
  saleorProductVariantId?: Maybe<Scalars['String']['output']>;
  serviceId: Scalars['String']['output'];
  slots: Scalars['Float']['output'];
  staffId: Scalars['String']['output'];
};

export type Shift = {
  id: Scalars['String']['input'];
  version: Scalars['Float']['input'];
};

export type ShiftInput = {
  active: Scalars['Boolean']['input'];
  comment: Scalars['String']['input'];
  day: Scalars['String']['input'];
  doctorId: Scalars['String']['input'];
  hourEnd: Scalars['String']['input'];
  hourStart: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
  placement: Placement;
  shiftType: Scalars['String']['input'];
  slotDurationString: Scalars['String']['input'];
};

export type ShiftOutputBase = {
  __typename?: 'ShiftOutputBase';
  active: Scalars['Boolean']['output'];
  comment: Scalars['String']['output'];
  day: Scalars['String']['output'];
  doctorId: Scalars['String']['output'];
  hourEnd: Scalars['String']['output'];
  hourStart: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  placement: Placement;
  shiftType: Scalars['String']['output'];
};

export type ShiftOutputDynamic = {
  __typename?: 'ShiftOutputDynamic';
  active: Scalars['Boolean']['output'];
  background: Scalars['String']['output'];
  comment: Scalars['String']['output'];
  day: Scalars['String']['output'];
  defaultSlotLength: Scalars['Int']['output'];
  doctorId: Scalars['String']['output'];
  draftData?: Maybe<ShiftOutputBase>;
  hourEnd: Scalars['String']['output'];
  hourStart: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  placeId: Scalars['String']['output'];
  placement: Placement;
  shiftType: Scalars['String']['output'];
  slotDuration: Scalars['Int']['output'];
  textColor: Scalars['String']['output'];
};


export type ShiftOutputDynamicbackgroundArgs = {
  oldTheme?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ShiftOutputDynamictextColorArgs = {
  oldTheme?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ShiftsOutput = {
  __typename?: 'ShiftsOutput';
  doctorIds: Array<Scalars['String']['output']>;
  shifts: Array<ShiftOutputDynamic>;
};

export type ShiftsSlot = {
  from: Scalars['DateTime']['input'];
  shifts: Array<Shift>;
  to: Scalars['DateTime']['input'];
};

export type SlotType =
  | 'COLLECTION'
  | 'DIETARY'
  | 'EXPRESS'
  | 'HOME'
  | 'INFECTIONS'
  | 'INFECTIONS_PRIVATE'
  | 'INFECTIONS_PUBLIC'
  | 'MIDWIFE'
  | 'NURSE_VISIT'
  | 'PERSONAL'
  | 'PROCEDURES'
  | 'SPECIALIST'
  | 'SPECIALIST_DOCTOR'
  | 'TELEMEDICAL'
  | 'TELEMEDICAL_NEW_CITIES'
  | 'TELEMEDICAL_PRIVATE'
  | 'USG';

export type Snippet = {
  __typename?: 'Snippet';
  category: Scalars['String']['output'];
  content: Scalars['String']['output'];
  counter: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  ownerId?: Maybe<Scalars['String']['output']>;
  priority: Scalars['Int']['output'];
  tags: Array<SelectOption>;
  type: SnippetType;
  visibility: SnippetVisibility;
};

export type SnippetEntity = {
  __typename?: 'SnippetEntity';
  category?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  counter: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  ownerId?: Maybe<Scalars['String']['output']>;
  priority: Scalars['Float']['output'];
  tags: Scalars['JSON']['output'];
  type: SnippetType;
  visibility: SnippetVisibility;
};

export type SnippetInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  counter?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<SelectOptionInput>>;
  type?: InputMaybe<SnippetType>;
  visibility?: InputMaybe<SnippetVisibility>;
};

export type SnippetType =
  | 'CHAT'
  | 'DOCS'
  | 'USG';

export type SnippetVisibility =
  | 'PRIVATE'
  | 'PUBLIC';

export type Spiro = BaseVital & Global & {
  __typename?: 'Spiro';
  comments?: Maybe<Scalars['String']['output']>;
  createdAt: Time;
  customDate?: Maybe<Time>;
  delivered?: Maybe<Time>;
  doctor?: Maybe<Doctor>;
  doctorId: Scalars['String']['output'];
  file?: Maybe<Scalars['String']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  measured?: Maybe<Time>;
  message?: Maybe<Message>;
  messageId: Scalars['String']['output'];
  overrideFiles?: Maybe<Array<Scalars['String']['output']>>;
  patient?: Maybe<Patient>;
  patientId: Scalars['String']['output'];
  type: VitalType;
  updatedAt: Time;
  visit?: Maybe<Visit>;
  visitId: Scalars['String']['output'];
};

export type StaffEntity = {
  __typename?: 'StaffEntity';
  avatar?: Maybe<Scalars['String']['output']>;
  blocked: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  declaringToOrganizationId: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Scalars['JSON']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  genre: UserGenre;
  hiddenSnippets?: Maybe<Array<Scalars['String']['output']>>;
  history?: Maybe<History>;
  id: Scalars['String']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isDeclarable?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  medicalPushToken?: Maybe<Scalars['JSON']['output']>;
  organizationId: Scalars['String']['output'];
  pesel?: Maybe<Scalars['String']['output']>;
  pushToken?: Maybe<Scalars['String']['output']>;
  sipNumber?: Maybe<Scalars['String']['output']>;
  sipNumberRecording?: Maybe<Scalars['String']['output']>;
  sipUserId?: Maybe<Scalars['String']['output']>;
  sipUserIdRecording?: Maybe<Scalars['String']['output']>;
  sipUserPassword?: Maybe<Scalars['String']['output']>;
  sipUserPasswordRecording?: Maybe<Scalars['String']['output']>;
  uniqueIntegerId?: Maybe<Scalars['Float']['output']>;
  unread: Scalars['Float']['output'];
  unsuccessfulAuth?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type StateInsurance =
  | 'KRUS'
  | 'OTHER_COUNTRY'
  | 'OTHER_IN_POLAND'
  | 'ZUS';

export type StayAddress = {
  __typename?: 'StayAddress';
  city: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  flatNumber?: Maybe<Scalars['String']['output']>;
  houseNumber: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  street: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type StayAddressInput = {
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  flatNumber?: InputMaybe<Scalars['String']['input']>;
  houseNumber: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type StreetPrefix =
  | 'AL'
  | 'PL'
  | 'RONDO'
  | 'SKWER'
  | 'UL';

export type Subscription = {
  __typename?: 'Subscription';
  handleMessagesUpdates: ChatMessagesUpdateEvent;
};


export type SubscriptionhandleMessagesUpdatesArgs = {
  patientId: Scalars['String']['input'];
};

export type SupportedLanguage =
  | 'EN'
  | 'PL'
  | 'RU'
  | 'UK';

export type Survey = {
  __typename?: 'Survey';
  height: Scalars['String']['output'];
  risks: Array<Answer>;
  weight: Scalars['String']['output'];
};

export type SurveyProposal = {
  __typename?: 'SurveyProposal';
  createdAt: Scalars['String']['output'];
  data: Scalars['JSON']['output'];
  formId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isFilled: Scalars['Boolean']['output'];
  patientId: Scalars['String']['output'];
  schema: Scalars['JSON']['output'];
  updatedAt: Scalars['String']['output'];
  visitId: Scalars['String']['output'];
};

export type SurveyProposalEntity = {
  __typename?: 'SurveyProposalEntity';
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  formId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isFilled: Scalars['String']['output'];
  patientId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SurveyProposalInput = {
  formId: Scalars['String']['input'];
  patientId: Scalars['String']['input'];
};

export type TagType =
  | 'DOCTOR'
  | 'EXAMINATION'
  | 'LOCALIZATION'
  | 'OFFICE';

export type Term = {
  __typename?: 'Term';
  date: Scalars['String']['output'];
  doctorId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  intervals: Array<DoctorInterval>;
  slotSize: Scalars['Int']['output'];
  tags: Array<TermTag>;
  type: TermType;
};

export type TermTag = {
  __typename?: 'TermTag';
  type: TagType;
  userId: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TermType =
  | 'BLOCKER'
  | 'DOCTORDAY'
  | 'DOCTORWEEK'
  | 'PLACE';

export type Testimonial = BaseMessage & Global & {
  __typename?: 'Testimonial';
  createdAt: Time;
  data: Scalars['JSON']['output'];
  doctor: Doctor;
  doctorId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  patient: Patient;
  patientId: Scalars['String']['output'];
  stripeSessionId: Scalars['String']['output'];
  testimonialType: Scalars['String']['output'];
  type: MessageType;
  updatedAt: Time;
  visit: Visit;
  visitId: Scalars['String']['output'];
};

export type TestimonialGenerationInput = {
  selectedDocument: SelectedDocumentInput;
  visitId: Scalars['String']['input'];
};

export type TidyDocumentationResultEntity = {
  __typename?: 'TidyDocumentationResultEntity';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  medicalRecord: MedicalRecordEntity;
  name?: Maybe<Scalars['String']['output']>;
  rawText?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['JSON']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Time = {
  __typename?: 'Time';
  iso: Scalars['String']['output'];
  local: Scalars['String']['output'];
};

export type TodoEntity = {
  __typename?: 'TodoEntity';
  content?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  maximalDate?: Maybe<Scalars['DateTime']['output']>;
  minimalDate?: Maybe<Scalars['DateTime']['output']>;
  organizationId: Scalars['String']['output'];
  patientId: Scalars['String']['output'];
  plannedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type TodoStatus =
  | 'DONE'
  | 'ERROR'
  | 'PREVIOUSLY_DONE'
  | 'TODO';

export type TokensPayload = {
  __typename?: 'TokensPayload';
  error?: Maybe<Scalars['String']['output']>;
  jwt?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
};

export type TuberculosisEducationInput = {
  patientEducated?: InputMaybe<Scalars['Boolean']['input']>;
  riskGroup?: InputMaybe<TuberculosisRiskLevel>;
  score?: InputMaybe<Scalars['Float']['input']>;
  telemedicalConsultation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TuberculosisRiskLevel =
  | 'HIGH'
  | 'MODERATE'
  | 'NO_RISK';

export type UnderCarePerson = {
  __typename?: 'UnderCarePerson';
  birthDate: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type UnderCarePersonType =
  | 'CHILD'
  | 'OTHER'
  | 'RELATIVE';

export type UnknownEvent = NfzEventBase & {
  __typename?: 'UnknownEvent';
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type UpdateDocumentInput = {
  starred?: InputMaybe<Scalars['Boolean']['input']>;
  tagId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProcedureInput = {
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  patientId?: InputMaybe<Scalars['String']['input']>;
  visitId?: InputMaybe<Scalars['String']['input']>;
};

export type User = Doctor | Patient;

export type UserEntity = {
  __typename?: 'UserEntity';
  acCohort?: Maybe<Scalars['Float']['output']>;
  acTimestamp: Scalars['Float']['output'];
  acTimestampStart: Scalars['Float']['output'];
  address?: Maybe<Address>;
  analyticsData?: Maybe<AnalyticsData>;
  analyticsId?: Maybe<Scalars['String']['output']>;
  assistantId?: Maybe<Scalars['String']['output']>;
  avatar?: Maybe<Scalars['String']['output']>;
  blocked: Scalars['Boolean']['output'];
  blockedTelemedicine: Scalars['Boolean']['output'];
  chosenDoctor?: Maybe<Scalars['String']['output']>;
  chosenNurse?: Maybe<Scalars['String']['output']>;
  citizenship?: Maybe<Scalars['String']['output']>;
  clientAppSettings?: Maybe<ClientAppSettings>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  declarationType?: Maybe<Scalars['String']['output']>;
  declarations?: Maybe<Array<Declaration>>;
  deviceInfo?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  ewusCheck?: Maybe<EwusCheck>;
  ewusCheckHistory?: Maybe<History>;
  files?: Maybe<Scalars['JSON']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  genre: UserGenre;
  hiddenSnippets?: Maybe<Array<Scalars['String']['output']>>;
  history?: Maybe<History>;
  id: Scalars['String']['output'];
  immunizationCardComment: Scalars['String']['output'];
  immunizationCardStatus: Scalars['String']['output'];
  immunizationStatus: Scalars['Float']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isQualifiedToCHUK: Scalars['Boolean']['output'];
  izolacja?: Maybe<Scalars['String']['output']>;
  kwarantanna?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastPatientMessageBlock?: Maybe<Scalars['Float']['output']>;
  llmAgreement?: Maybe<Scalars['Boolean']['output']>;
  marketing?: Maybe<Scalars['Boolean']['output']>;
  medicalDataAnalysisAgreement?: Maybe<Scalars['Boolean']['output']>;
  medicalPushToken?: Maybe<Scalars['JSON']['output']>;
  mobileAppVersion?: Maybe<Scalars['String']['output']>;
  oneTimeSurvey?: Maybe<Survey>;
  oneTimeSurveyUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  organizationId: Scalars['String']['output'];
  passportCountry?: Maybe<Scalars['String']['output']>;
  passportNumber?: Maybe<Scalars['String']['output']>;
  patientCardNumber?: Maybe<Scalars['String']['output']>;
  patientPublicSince?: Maybe<Scalars['DateTime']['output']>;
  pesel?: Maybe<Scalars['String']['output']>;
  phoneMarketingAgreement?: Maybe<Scalars['Boolean']['output']>;
  pushToken?: Maybe<Scalars['String']['output']>;
  referralCode?: Maybe<Scalars['String']['output']>;
  registrationType?: Maybe<Scalars['String']['output']>;
  secretData?: Maybe<SecretData>;
  selfOrdinatedDrugs?: Maybe<Array<SelfOrdinatedDrugDto>>;
  signature?: Maybe<Scalars['String']['output']>;
  stateInsurance: StateInsurance;
  statusUbezpieczenia?: Maybe<Scalars['String']['output']>;
  stayAddresses?: Maybe<Array<StayAddress>>;
  uniqueIntegerId?: Maybe<Scalars['Float']['output']>;
  unread: Scalars['Float']['output'];
  unsuccessfulAuth?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  usedReferralCode?: Maybe<Scalars['String']['output']>;
  visitRecordingAndAnalysisAgreement?: Maybe<Scalars['Boolean']['output']>;
};

export type UserGenre =
  | 'ASSISTANT'
  | 'CLINIC_MANAGER'
  | 'DOCTOR'
  | 'MODERATOR'
  | 'NURSE'
  | 'PATIENT'
  | 'STAFF';

export type UsersNotificationAgreementsEntity = {
  __typename?: 'UsersNotificationAgreementsEntity';
  agreed: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type Usg = BaseVital & Global & {
  __typename?: 'Usg';
  createdAt: Time;
  customDate?: Maybe<Time>;
  delivered?: Maybe<Time>;
  doctor?: Maybe<Doctor>;
  doctorId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  measured?: Maybe<Time>;
  message?: Maybe<Message>;
  messageId: Scalars['String']['output'];
  overrideFiles?: Maybe<Array<Scalars['String']['output']>>;
  patient?: Maybe<Patient>;
  patientId: Scalars['String']['output'];
  type: VitalType;
  updatedAt: Time;
  visit?: Maybe<Visit>;
  visitId: Scalars['String']['output'];
};

export type UsgInput = {
  attachments?: InputMaybe<Array<Scalars['String']['input']>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  referralId?: InputMaybe<Scalars['String']['input']>;
  serviceId?: InputMaybe<Scalars['String']['input']>;
};

export type VaccineInput = {
  dose?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productSeries?: InputMaybe<Scalars['String']['input']>;
};

export type Visit = Global & {
  __typename?: 'Visit';
  additionalMedicalService?: Maybe<Array<Scalars['String']['output']>>;
  appointmentStatus: Scalars['String']['output'];
  availableImaginingOrganizationId: Scalars['String']['output'];
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  children: Array<Visit>;
  closedByBot?: Maybe<Scalars['Boolean']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Time;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdByUsername: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  determineIpomEligibility: Scalars['Boolean']['output'];
  diagId?: Maybe<Scalars['Int']['output']>;
  diagnosis: Array<Diagnosis>;
  doctor?: Maybe<Doctor>;
  doctorDiagnosis?: Maybe<Array<Maybe<Diagnosis>>>;
  doctorId?: Maybe<Scalars['String']['output']>;
  doctorInterview?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  ecommerceOrderIds: Array<Scalars['String']['output']>;
  faqRead?: Maybe<Array<FaqType>>;
  faqTypes: Array<AssignmentFaqType>;
  height?: Maybe<Scalars['Int']['output']>;
  icd10Main?: Maybe<ICD10Main>;
  icd10Secondary?: Maybe<ICD10Main>;
  id: Scalars['String']['output'];
  innatePriority: VisitPriority;
  invitationSentAt?: Maybe<Time>;
  invitationSentBy?: Maybe<Doctor>;
  isPublicVisit: Scalars['Boolean']['output'];
  laboratoryExaminations: Array<LaboratoryExaminationEntity>;
  leftOn?: Maybe<Scalars['String']['output']>;
  memo?: Maybe<Scalars['String']['output']>;
  note: Scalars['String']['output'];
  nurseDiagnosis?: Maybe<Array<Diagnosis>>;
  nursePhysicalExamination?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  patient?: Maybe<Patient>;
  patientId: Scalars['String']['output'];
  physicalExamination?: Maybe<Scalars['String']['output']>;
  plannedPlace?: Maybe<Scalars['String']['output']>;
  plannedStart?: Maybe<Time>;
  preInterview?: Maybe<Array<LlmChatMessage>>;
  prescriptionRequest?: Maybe<PrescriptionRequestDto>;
  prescriptionRequestId?: Maybe<Scalars['String']['output']>;
  primaryMedicalService?: Maybe<PrimaryMedicalService>;
  procedures: Array<ProcedureEntity>;
  rating: VisitsRatingEntity;
  recommendation?: Maybe<Scalars['String']['output']>;
  recommendationsMessage?: Maybe<ChatMessageEntity>;
  recommendationsMessageId?: Maybe<Scalars['String']['output']>;
  sentNoShowNotifications?: Maybe<SentNoShowNotifications>;
  serviceId?: Maybe<Scalars['String']['output']>;
  serviceStaff?: Maybe<ServiceStaffEntity>;
  showOn?: Maybe<Scalars['String']['output']>;
  slotType?: Maybe<Scalars['String']['output']>;
  smokeLevel?: Maybe<Scalars['Int']['output']>;
  smsNotifications: SMSNotifications;
  snapshotAt?: Maybe<Scalars['String']['output']>;
  snapshotBy?: Maybe<Scalars['String']['output']>;
  source: Visit;
  startOn?: Maybe<Scalars['String']['output']>;
  status: VisitStatus;
  surveys: Array<SurveyProposal>;
  timeStatus: VisitComplexStatus;
  type?: Maybe<VisitType>;
  updatedAt: Time;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type VisitComplexStatus =
  | 'PAST'
  | 'UPCOMING';

export type VisitFilterInput = {
  additionalMedicalService?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  patientSearch?: InputMaybe<Scalars['String']['input']>;
  primaryMedicalService?: InputMaybe<Array<PrimaryMedicalService>>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<VisitStatus>>;
  visitType?: InputMaybe<Array<VisitType>>;
};

export type VisitInput = {
  additionalMedicalService?: InputMaybe<Array<Scalars['String']['input']>>;
  appointmentStatus?: InputMaybe<AppointmentStatus>;
  comment?: InputMaybe<Scalars['String']['input']>;
  doctorDiagnosis?: InputMaybe<Array<InputMaybe<DiagnosisInput>>>;
  doctorInterview?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  icd10Main?: InputMaybe<ICD10Input>;
  icd10Secondary?: InputMaybe<ICD10Input>;
  innatePriority?: InputMaybe<VisitPriority>;
  memo?: InputMaybe<Scalars['String']['input']>;
  nurseDiagnosis?: InputMaybe<Array<InputMaybe<DiagnosisInput>>>;
  nursePhysicalExamination?: InputMaybe<Scalars['String']['input']>;
  physicalExamination?: InputMaybe<Scalars['String']['input']>;
  prenterview?: InputMaybe<Scalars['String']['input']>;
  primaryMedicalService?: InputMaybe<PrimaryMedicalService>;
  recommendation?: InputMaybe<Scalars['String']['input']>;
  smokeLevel?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type VisitPriority =
  | 'IMMEDIATE'
  | 'INDETERMINATE'
  | 'STANDARD'
  | 'URGENT';

export type VisitStatus =
  | 'ARCHIVE'
  | 'DRAFT'
  | 'INPROGRESS'
  | 'SUCCESS';

export type VisitType =
  | 'PROCEDURE'
  | 'STANDARD'
  | 'VIRTUAL';

export type VisitsRatingEntity = {
  __typename?: 'VisitsRatingEntity';
  answers: Scalars['JSON']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  formId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  rating: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
  visitId: Scalars['String']['output'];
};

export type Vital = Analysis | Ct | Ecommerce | Ekg | Heartrate | Injection | Operation | Other | Pressure | Rtg | Spiro | Usg;

export type VitalEntity = {
  __typename?: 'VitalEntity';
  analysisType?: Maybe<Scalars['String']['output']>;
  closed?: Maybe<Scalars['Boolean']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customComment?: Maybe<Scalars['String']['output']>;
  customDate?: Maybe<Scalars['String']['output']>;
  customName?: Maybe<Scalars['String']['output']>;
  delivered?: Maybe<Scalars['String']['output']>;
  diastolic?: Maybe<Scalars['String']['output']>;
  doctorId?: Maybe<Scalars['String']['output']>;
  drugs: Scalars['JSON']['output'];
  genre?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  injectionType?: Maybe<Scalars['String']['output']>;
  measured?: Maybe<Scalars['String']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  overrideFiles: Scalars['JSON']['output'];
  params: Scalars['JSON']['output'];
  patientId?: Maybe<Scalars['String']['output']>;
  positionId?: Maybe<Scalars['String']['output']>;
  rate?: Maybe<Scalars['String']['output']>;
  systolic?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  visitId?: Maybe<Scalars['String']['output']>;
};

export type VitalInput = {
  overrideFiles: Array<Scalars['String']['input']>;
  patientId: Scalars['String']['input'];
  type: VitalType;
};

export type VitalParam = {
  __typename?: 'VitalParam';
  icd9: Scalars['String']['output'];
  max: Scalars['String']['output'];
  min: Scalars['String']['output'];
  name: Scalars['String']['output'];
  text: Scalars['String']['output'];
  unit: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type VitalParamInput = {
  icd9: Scalars['String']['input'];
  max: Scalars['String']['input'];
  min: Scalars['String']['input'];
  name: Scalars['String']['input'];
  text: Scalars['String']['input'];
  unit: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type VitalType =
  | 'ANALYSIS'
  | 'CT'
  | 'ECOMMERCE'
  | 'EKG'
  | 'HEARTRATE'
  | 'INJECTION'
  | 'OPERATION'
  | 'OTHER'
  | 'PRESSURE'
  | 'RTG'
  | 'SPIRO'
  | 'USG';

export type WardDetails = {
  __typename?: 'WardDetails';
  name: Scalars['String']['output'];
};

export type WeekDay =
  | 'Friday'
  | 'Monday'
  | 'Saturday'
  | 'Sunday'
  | 'Thursday'
  | 'Tuesday'
  | 'Wednesday';

export type WoundHealingStatus =
  | 'CORRECT'
  | 'UNDER_SCAB'
  | 'WITHOUT_SCAB';

export type ZAS2TestimonialInput = {
  expectedDateOfBirth?: InputMaybe<ExpectedDateOfBirthInput>;
  inabilityToWork?: InputMaybe<InabilityToWorkInput>;
  lastDayOfWork?: InputMaybe<LastDayOfWorkInput>;
};

export type ZAS38TestimonialInput = {
  careSince: Scalars['DateTime']['input'];
  careUntil: Scalars['DateTime']['input'];
  children: Array<PersonMinimalDataInput>;
  otherParent: PersonMinimalDataInput;
  whyNotOtherParent: Scalars['String']['input'];
};

export type ZusMedicalLeave = {
  __typename?: 'ZusMedicalLeave';
  doctorFirstName: Scalars['String']['output'];
  doctorLastName: Scalars['String']['output'];
  doctorNpwz: Scalars['String']['output'];
  hospitalizationDaysCount: Scalars['String']['output'];
  id: Scalars['String']['output'];
  incapacityEndDate: Scalars['String']['output'];
  incapacityStartDate: Scalars['String']['output'];
  insuredPersonFirstName: Scalars['String']['output'];
  insuredPersonLastName: Scalars['String']['output'];
  insuredPersonPesel: Scalars['String']['output'];
  leaveIssueDate: Scalars['String']['output'];
  leaveNumber: Scalars['String']['output'];
  leaveSeries: Scalars['String']['output'];
  leaveStatus: Scalars['String']['output'];
  payerIdentifier: Scalars['String']['output'];
  payerIdentifierType: Scalars['String']['output'];
  /** 0 - brak osoby pod opieką „1” – dziecko; „2” - małżonek, rodzice, ojczym, macocha, teściowie, dziadkowie, wnuki, rodzeństwo; „3” – inne osoby */
  relationshipCode?: Maybe<Scalars['String']['output']>;
  statisticalDiseaseNumber: Scalars['String']['output'];
};

export type ZusPayer = {
  __typename?: 'ZusPayer';
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nip: Scalars['String']['output'];
  passportNumber: Scalars['String']['output'];
  pesel: Scalars['String']['output'];
  pueProfile: Scalars['Boolean']['output'];
};

export type PrescriptionPartsFragment = { __typename?: 'Prescription', id: string, type: MessageType, resourceCancelationInCezDate?: any | null, insuredIn: string, code: string, number: string, prescriptionId?: string | null, visit: { __typename?: 'Visit', id: string }, createdAt: { __typename?: 'Time', iso: string }, updatedAt: { __typename?: 'Time', iso: string }, writeup: { __typename?: 'Time', iso: string }, doctor: { __typename?: 'Doctor', id: string, firstName?: string | null, lastName?: string | null, avatar: string }, patient: { __typename?: 'Patient', firstName?: string | null, lastName?: string | null, pesel?: string | null }, startsToWork?: { __typename?: 'Time', iso: string } | null, endsToWork?: { __typename?: 'Time', iso: string } | null, options?: { __typename?: 'PrescriptionOptions', in365days?: boolean | null, cito?: boolean | null, dontChange?: boolean | null } | null, drugs: Array<{ __typename?: 'Drug', cost: string, drug: string, boxAmount?: number | null, dose: string, form: string, interval?: string | null, hourInterval?: number | null, drugAmount?: number | null, quantity?: string | null, psychoSubstances?: boolean | null, morePatientInfo?: string | null, morePharmacistInfo?: string | null, activeSubstances?: Array<{ __typename?: 'ActiveSubstance', activeSubstanceDose?: number | null, activeSubstanceDoseInWords?: Array<string> | null, activeSubstanceDoseUnit?: string | null } | null> | null }> };

export type HandleMessagesUpdatesSubscriptionVariables = Exact<{
  patientId: Scalars['String']['input'];
}>;


export type HandleMessagesUpdatesSubscription = { __typename?: 'Subscription', handleMessagesUpdates: { __typename: 'ChatMessageCreatedEvent', message: { __typename?: 'ChatMessageEntity', id: string, content: string, authorId?: string | null, patientId: string, createdAt: any, updatedAt: any, deletedAt?: any | null, author?: { __typename: 'Doctor', id: string, genre: UserGenre, firstName?: string | null, lastName?: string | null } | { __typename: 'Patient', id: string, genre: UserGenre, firstName?: string | null, lastName?: string | null, guardians: Array<{ __typename?: 'Patient', id: string, firstName?: string | null, lastName?: string | null }> } | null, visit?: { __typename?: 'Visit', id: string, status: VisitStatus, duration?: number | null, doctor?: { __typename?: 'Doctor', id: string, firstName?: string | null, lastName?: string | null, avatar: string } | null, plannedStart?: { __typename?: 'Time', iso: string } | null } | null, survey?: { __typename?: 'SurveyProposalEntity', formId: string, data?: any | null, isFilled: string } | null, prescription?: { __typename?: 'Prescription', id: string, type: MessageType, resourceCancelationInCezDate?: any | null, insuredIn: string, code: string, number: string, prescriptionId?: string | null, visit: { __typename?: 'Visit', id: string }, createdAt: { __typename?: 'Time', iso: string }, updatedAt: { __typename?: 'Time', iso: string }, writeup: { __typename?: 'Time', iso: string }, doctor: { __typename?: 'Doctor', id: string, firstName?: string | null, lastName?: string | null, avatar: string }, patient: { __typename?: 'Patient', firstName?: string | null, lastName?: string | null, pesel?: string | null }, startsToWork?: { __typename?: 'Time', iso: string } | null, endsToWork?: { __typename?: 'Time', iso: string } | null, options?: { __typename?: 'PrescriptionOptions', in365days?: boolean | null, cito?: boolean | null, dontChange?: boolean | null } | null, drugs: Array<{ __typename?: 'Drug', cost: string, drug: string, boxAmount?: number | null, dose: string, form: string, interval?: string | null, hourInterval?: number | null, drugAmount?: number | null, quantity?: string | null, psychoSubstances?: boolean | null, morePatientInfo?: string | null, morePharmacistInfo?: string | null, activeSubstances?: Array<{ __typename?: 'ActiveSubstance', activeSubstanceDose?: number | null, activeSubstanceDoseInWords?: Array<string> | null, activeSubstanceDoseUnit?: string | null } | null> | null }> } | null, leave?: { __typename?: 'Leave', id: string, type: MessageType, reason?: string | null, leaveType?: string | null, insuredIn?: string | null, inabilitySince?: string | null, inabilityUntil?: string | null, careSince?: string | null, careUntil?: string | null, doNotSendPayerInfo?: boolean | null, recommendation?: string | null, doctor: { __typename?: 'Doctor', id: string }, visit: { __typename?: 'Visit', id: string }, createdAt: { __typename?: 'Time', iso: string }, updatedAt: { __typename?: 'Time', iso: string }, icd10Main: { __typename?: 'ICD10Main', name: string, icd10: string }, codes?: { __typename?: 'Codes', A: boolean, B: boolean, C: boolean, D: boolean, E: boolean } | null, payer?: { __typename?: 'Payer', id?: string | null } | null, payers?: Array<{ __typename?: 'Payer', id?: string | null, name: string, firstName: string, lastName: string, nip: string, pesel: string, passportNumber: string, doNotSendPayerInfo?: boolean | null }> | null, underCarePerson?: { __typename?: 'UnderCarePerson', firstName: string } | null, leaves?: Array<{ __typename?: 'LeaveDetails', seriesNumber: string, address?: { __typename?: 'LeaveAddress', city: string, country?: string | null, street: string, houseNumber: string, flatNumber?: string | null, zipCode: string, notes?: string | null } | null, guardian?: { __typename?: 'LeaveGuardian', firstName: string, lastName: string, pesel: string } | null }> | null } | null, careleave?: { __typename?: 'Careleave', id: string, insuredIn?: string | null, careSince?: string | null, careUntil?: string | null, doNotSendPayerInfo?: boolean | null, recommendation?: string | null, doctor: { __typename?: 'Doctor', id: string }, visit: { __typename?: 'Visit', id: string }, createdAt: { __typename?: 'Time', iso: string }, updatedAt: { __typename?: 'Time', iso: string }, icd10Main: { __typename?: 'ICD10Main', name: string, icd10: string }, payer?: { __typename?: 'Payer', id?: string | null } | null, payers?: Array<{ __typename?: 'Payer', id?: string | null, name: string, firstName: string, lastName: string, nip: string, pesel: string, passportNumber: string, doNotSendPayerInfo?: boolean | null }> | null, underCarePerson?: { __typename?: 'UnderCarePerson', firstName: string } | null, leaves?: Array<{ __typename?: 'LeaveDetails', seriesNumber: string, address?: { __typename?: 'LeaveAddress', city: string, country?: string | null, street: string, houseNumber: string, flatNumber?: string | null, zipCode: string, notes?: string | null } | null, guardian?: { __typename?: 'LeaveGuardian', firstName: string, lastName: string, pesel: string } | null }> | null } | null, testimonial?: { __typename?: 'Testimonial', id: string, type: MessageType, testimonialType: string, data: any, createdAt: { __typename?: 'Time', iso: string }, visit: { __typename?: 'Visit', id: string } } | null, referral?: { __typename?: 'Referral', id: string, type: MessageType, referralType: string, urgent?: boolean | null, comment?: string | null, createdAt: { __typename?: 'Time', iso: string }, visit: { __typename?: 'Visit', id: string }, icd10?: { __typename?: 'ICD10Main', icd10: string, name: string } | null, icd9?: { __typename?: 'ICD9Main', icd9: string, name: string } | null, clinic?: { __typename?: 'ClinicDetails', name: string } | null, referralDetails: { __typename?: 'ReferralDetails', code?: string | null } } | null, assignment?: { __typename?: 'Assignment', id: string, type: MessageType, assignmentType: string, data?: any | null, createdAt: { __typename?: 'Time', iso: string }, visit: { __typename?: 'Visit', id: string }, updatedAt: { __typename?: 'Time', iso: string }, doctor: { __typename?: 'Doctor', firstName?: string | null, lastName?: string | null }, positions?: Array<{ __typename?: 'Position', serviceId?: string | null, serviceName?: string | null, sampleId?: string | null, cancelled?: boolean | null, isNFZ?: boolean | null, price?: number | null, positionData?: { __typename?: 'DynamicPositionData', color: string, type: string, material: string } | null } | null> | null } | null } } | { __typename: 'ChatMessageDeletedEvent', message: { __typename?: 'ChatMessageEntity', id: string } } | { __typename: 'PrescriptionChatMessageDeletedEvent', message: { __typename?: 'ChatMessageEntity', id: string, prescription?: { __typename?: 'Prescription', id: string, type: MessageType, resourceCancelationInCezDate?: any | null, insuredIn: string, code: string, number: string, prescriptionId?: string | null, visit: { __typename?: 'Visit', id: string }, createdAt: { __typename?: 'Time', iso: string }, updatedAt: { __typename?: 'Time', iso: string }, writeup: { __typename?: 'Time', iso: string }, doctor: { __typename?: 'Doctor', id: string, firstName?: string | null, lastName?: string | null, avatar: string }, patient: { __typename?: 'Patient', firstName?: string | null, lastName?: string | null, pesel?: string | null }, startsToWork?: { __typename?: 'Time', iso: string } | null, endsToWork?: { __typename?: 'Time', iso: string } | null, options?: { __typename?: 'PrescriptionOptions', in365days?: boolean | null, cito?: boolean | null, dontChange?: boolean | null } | null, drugs: Array<{ __typename?: 'Drug', cost: string, drug: string, boxAmount?: number | null, dose: string, form: string, interval?: string | null, hourInterval?: number | null, drugAmount?: number | null, quantity?: string | null, psychoSubstances?: boolean | null, morePatientInfo?: string | null, morePharmacistInfo?: string | null, activeSubstances?: Array<{ __typename?: 'ActiveSubstance', activeSubstanceDose?: number | null, activeSubstanceDoseInWords?: Array<string> | null, activeSubstanceDoseUnit?: string | null } | null> | null }> } | null } } };

export const PrescriptionPartsFragmentDoc = gql`
    fragment PrescriptionParts on Prescription {
  id
  type
  visit {
    id
  }
  createdAt {
    iso
  }
  updatedAt {
    iso
  }
  resourceCancelationInCezDate
  writeup {
    iso
  }
  doctor {
    id
    firstName
    lastName
    avatar
  }
  patient {
    firstName
    lastName
    pesel
  }
  startsToWork {
    iso
  }
  endsToWork {
    iso
  }
  insuredIn
  code
  number
  prescriptionId
  options {
    in365days
    cito
    dontChange
  }
  drugs {
    cost
    drug
    boxAmount
    dose
    form
    interval
    hourInterval
    drugAmount
    interval
    quantity
    psychoSubstances
    activeSubstances {
      activeSubstanceDose
      activeSubstanceDoseInWords
      activeSubstanceDoseUnit
    }
    hourInterval
    morePatientInfo
    morePharmacistInfo
    morePatientInfo
  }
}
    `;
export const HandleMessagesUpdatesDocument = gql`
    subscription HandleMessagesUpdates($patientId: String!) {
  handleMessagesUpdates(patientId: $patientId) {
    ... on ChatMessageCreatedEvent {
      __typename
      message {
        id
        content
        authorId
        patientId
        createdAt
        updatedAt
        deletedAt
        author {
          __typename
          ... on BaseUser {
            id
            genre
            firstName
            lastName
          }
          ... on Patient {
            __typename
            guardians {
              id
              firstName
              lastName
            }
          }
        }
        visit {
          id
          doctor {
            id
            firstName
            lastName
            avatar
          }
          plannedStart {
            iso
          }
          status
          duration
        }
        survey {
          formId
          data
          isFilled
        }
        prescription {
          ...PrescriptionParts
        }
        leave {
          id
          doctor {
            id
          }
          visit {
            id
          }
          type
          createdAt {
            iso
          }
          updatedAt {
            iso
          }
          reason
          leaveType
          insuredIn
          icd10Main {
            name
            icd10
          }
          inabilitySince
          inabilityUntil
          careSince
          careUntil
          doNotSendPayerInfo
          recommendation
          codes {
            A
            B
            C
            D
            E
          }
          payer {
            id
          }
          payers {
            id
            name
            firstName
            lastName
            nip
            pesel
            passportNumber
            doNotSendPayerInfo
          }
          underCarePerson {
            firstName
          }
          leaves {
            seriesNumber
            address {
              city
              country
              street
              houseNumber
              flatNumber
              zipCode
              notes
            }
            guardian {
              firstName
              lastName
              pesel
            }
          }
        }
        careleave {
          id
          doctor {
            id
          }
          visit {
            id
          }
          createdAt {
            iso
          }
          updatedAt {
            iso
          }
          insuredIn
          icd10Main {
            name
            icd10
          }
          careSince
          careUntil
          doNotSendPayerInfo
          recommendation
          payer {
            id
          }
          payers {
            id
            name
            firstName
            lastName
            nip
            pesel
            passportNumber
            doNotSendPayerInfo
          }
          underCarePerson {
            firstName
          }
          leaves {
            seriesNumber
            address {
              city
              country
              street
              houseNumber
              flatNumber
              zipCode
              notes
            }
            guardian {
              firstName
              lastName
              pesel
            }
          }
        }
        testimonial {
          id
          type
          testimonialType
          data
          createdAt {
            iso
          }
          visit {
            id
          }
        }
        referral {
          id
          type
          referralType
          urgent
          comment
          createdAt {
            iso
          }
          visit {
            id
          }
          icd10 {
            icd10
            name
          }
          icd9 {
            icd9
            name
          }
          clinic {
            name
          }
          referralDetails {
            code
          }
        }
        assignment {
          id
          type
          assignmentType
          createdAt {
            iso
          }
          visit {
            id
          }
          updatedAt {
            iso
          }
          doctor {
            firstName
            lastName
          }
          positions {
            serviceId
            serviceName
            sampleId
            cancelled
            positionData {
              color
              type
              material
            }
            isNFZ
            price
            cancelled
          }
          data
        }
      }
    }
    ... on ChatMessageDeletedEvent {
      __typename
      message {
        id
      }
    }
    ... on PrescriptionChatMessageDeletedEvent {
      __typename
      message {
        id
        prescription {
          ...PrescriptionParts
        }
      }
    }
  }
}
    ${PrescriptionPartsFragmentDoc}`;

/**
 * __useHandleMessagesUpdatesSubscription__
 *
 * To run a query within a React component, call `useHandleMessagesUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useHandleMessagesUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHandleMessagesUpdatesSubscription({
 *   variables: {
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useHandleMessagesUpdatesSubscription(baseOptions: Apollo.SubscriptionHookOptions<HandleMessagesUpdatesSubscription, HandleMessagesUpdatesSubscriptionVariables> & ({ variables: HandleMessagesUpdatesSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<HandleMessagesUpdatesSubscription, HandleMessagesUpdatesSubscriptionVariables>(HandleMessagesUpdatesDocument, options);
      }
export type HandleMessagesUpdatesSubscriptionHookResult = ReturnType<typeof useHandleMessagesUpdatesSubscription>;
export type HandleMessagesUpdatesSubscriptionResult = Apollo.SubscriptionResult<HandleMessagesUpdatesSubscription>;